import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactDOM from 'react-dom';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".Button_btn__3zXcJ {\n  background: none;\n  font-size: .875rem;\n  color: #5f6368;\n  background-color: #eaeaeb;\n  height: 36px;\n  padding: 0 16px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 3px;\n  border: none;\n  letter-spacing: .25px;\n  transition: .15s;\n  min-width: 100px;\n  outline: none; }\n\n.Button_btn__3zXcJ:hover,\n.Button_btn__3zXcJ:focus {\n  border: none; }\n\n.Button_btn__3zXcJ:focus {\n  background-color: #eaeaeb;\n  box-shadow: 0 0 0px 3px #d6d6d6; }\n\n.Button_btn__3zXcJ:active {\n  background-color: #eaeaeb; }\n\n.Button_btnPrimary__2h3yC {\n  background-color: #006eff;\n  color: #fff; }\n  .Button_btnPrimary__2h3yC:hover {\n    border: none; }\n\n.Button_btnSuccess__1eBBV {\n  background-color: #23d160;\n  color: #fff; }\n  .Button_btnSuccess__1eBBV:hover {\n    border: none; }\n\n.Button_btnDanger__2LJ8n {\n  background-color: #ff4444;\n  color: #fff; }\n  .Button_btnDanger__2LJ8n:hover {\n    border: none; }\n\n.Button_btnRounded__3bHtG {\n  border-radius: 2rem; }\n\n.Button_btnOutlinedPrimary__1ZYSO {\n  border: 2px solid !important;\n  background: none; }\n  .Button_btnOutlinedPrimary__1ZYSO:focus {\n    background: none; }\n\n.Button_btnOutlinedSuccess__UUNAb {\n  border: 2px solid !important;\n  background: none; }\n  .Button_btnOutlinedSuccess__UUNAb:focus {\n    background: none; }\n\n.Button_btnOutlinedDanger__p9dOo {\n  border: 2px solid !important;\n  background: none; }\n  .Button_btnOutlinedDanger__p9dOo:focus {\n    background: none; }\n\n.Button_btnOutlined__2S7nB {\n  border: 2px solid !important;\n  background: none; }\n  .Button_btnOutlined__2S7nB:focus {\n    background: none; }\n\n.Button_loadingBtn__2v4Nk {\n  opacity: .7;\n  pointer-events: none;\n  position: relative; }\n\n.Button_loadingBtn__2v4Nk:focus {\n  box-shadow: none !important; }\n\n.Button_loadingBtnIcon__3spLa {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n";
var styles = {
  "btn": "Button_btn__3zXcJ",
  "btnPrimary": "Button_btnPrimary__2h3yC",
  "btnSuccess": "Button_btnSuccess__1eBBV",
  "btnDanger": "Button_btnDanger__2LJ8n",
  "btnRounded": "Button_btnRounded__3bHtG",
  "btnOutlinedPrimary": "Button_btnOutlinedPrimary__1ZYSO",
  "btnOutlinedSuccess": "Button_btnOutlinedSuccess__UUNAb",
  "btnOutlinedDanger": "Button_btnOutlinedDanger__p9dOo",
  "btnOutlined": "Button_btnOutlined__2S7nB",
  "loadingBtn": "Button_loadingBtn__2v4Nk",
  "loadingBtnIcon": "Button_loadingBtnIcon__3spLa"
};
styleInject(css);
var css$1 = ".Icon_iconSvg__zqjt5 {\n  display: inline-block;\n  vertical-align: -webkit-baseline-middle; }\n\n.Icon_iconAnimation__3s2EL svg {\n  animation: Icon_iconSpin__3IcSI infinite 1.3s linear; }\n\n@keyframes Icon_iconSpin__3IcSI {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n.Icon_isSpinning__1unaC { }\n";
var styles$1 = {
  "iconSvg": "Icon_iconSvg__zqjt5",
  "iconAnimation": "Icon_iconAnimation__3s2EL",
  "iconSpin": "Icon_iconSpin__3IcSI",
  "isSpinning": "Icon_isSpinning__1unaC Icon_iconAnimation__3s2EL"
};
styleInject(css$1);
/**
 * Export `uid`
 */

var uid_1 = uid;
/**
 * Create a `uid`
 *
 * @param {String} len
 * @return {String} uid
 */

function uid(len) {
  len = len || 7;
  return Math.random().toString(35).substr(2, len);
}

var hexCharacters = 'a-f\\d';
var match3or4Hex = "#?[".concat(hexCharacters, "]{3}[").concat(hexCharacters, "]?");
var match6or8Hex = "#?[".concat(hexCharacters, "]{6}([").concat(hexCharacters, "]{2})?");
var nonHexChars = new RegExp("[^#".concat(hexCharacters, "]"), 'gi');
var validHexSize = new RegExp("^".concat(match3or4Hex, "$|^").concat(match6or8Hex, "$"), 'i');

var hexRgb = function hexRgb(hex) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof hex !== 'string' || nonHexChars.test(hex) || !validHexSize.test(hex)) {
    throw new TypeError('Expected a valid hex string');
  }

  hex = hex.replace(/^#/, '');
  var alpha = 1;

  if (hex.length === 8) {
    alpha = parseInt(hex.slice(6, 8), 16) / 255;
    hex = hex.slice(0, 6);
  }

  if (hex.length === 4) {
    alpha = parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
    hex = hex.slice(0, 3);
  }

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  var num = parseInt(hex, 16);
  var red = num >> 16;
  var green = num >> 8 & 255;
  var blue = num & 255;
  return options.format === 'array' ? [red, green, blue, alpha] : {
    red: red,
    green: green,
    blue: blue,
    alpha: alpha
  };
};

var CloseIcon = function CloseIcon(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: props.color,
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M567.962078,620.099332 L289.797979,341.935233 C275.400674,327.537928 275.400674,304.195284 289.797979,289.797979 C304.195284,275.400674 327.537928,275.400674 341.935233,289.797979 L620.099332,567.962078 L898.263431,289.797979 C912.660737,275.400674 936.00338,275.400674 950.400685,289.797979 C964.797991,304.195284 964.797991,327.537928 950.400685,341.935233 L672.236586,620.099332 L950.400685,898.263431 C964.797991,912.660737 964.797991,936.00338 950.400685,950.400685 C936.00338,964.797991 912.660737,964.797991 898.263431,950.400685 L620.099332,672.236586 L341.935233,950.400685 C327.537928,964.797991 304.195284,964.797991 289.797979,950.400685 C275.400674,936.00338 275.400674,912.660737 289.797979,898.263431 L567.962078,620.099332 Z",
    id: "Combined-Shape"
  })));
};

var ArrowBack = function ArrowBack(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: props.color,
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "ArrowBack",
    transform: "translate(206.000000, 345.000000)"
  }, React.createElement("path", {
    d: "M300.754255,63.3502311 L126.181139,238.107743 L791.399618,238.107743 C811.819208,238.107743 828.5,254.751316 828.5,275.412302 C828.5,296.073289 811.819208,312.716862 791.399618,312.716862 L126.181139,312.716862 L301.041855,487.474374 C315.421848,502.109239 315.134248,525.639807 300.754255,540.274673 C286.086662,554.62258 262.791073,554.62258 248.12348,539.987715 L11.1411949,301.812452 C7.97759639,298.368954 5.38919764,294.638498 3.37599861,290.047168 C1.36279958,285.455838 0.5,280.577549 0.5,275.699261 C0.5,265.942684 4.23879819,256.760023 11.1411949,249.586069 L248.12348,11.4108064 C262.215874,-3.51101734 285.799062,-3.79797549 300.466655,10.5499319 C315.134248,24.8978393 315.134248,48.7153656 300.754255,63.3502311 Z"
  }))));
};

var ArrowTop = function ArrowTop(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    transform: "translate(620.500000, 620.500000) rotate(90.000000) translate(-620.500000, -620.500000) translate(206.000000, 345.000000)",
    fill: props.color
  }, React.createElement("g", {
    id: "arrowTop"
  }, React.createElement("path", {
    d: "M300.754255,63.3502311 L126.181139,238.107743 L791.399618,238.107743 C811.819208,238.107743 828.5,254.751316 828.5,275.412302 C828.5,296.073289 811.819208,312.716862 791.399618,312.716862 L126.181139,312.716862 L301.041855,487.474374 C315.421848,502.109239 315.134248,525.639807 300.754255,540.274673 C286.086662,554.62258 262.791073,554.62258 248.12348,539.987715 L11.1411949,301.812452 C7.97759639,298.368954 5.38919764,294.638498 3.37599861,290.047168 C1.36279958,285.455838 0.5,280.577549 0.5,275.699261 C0.5,265.942684 4.23879819,256.760023 11.1411949,249.586069 L248.12348,11.4108064 C262.215874,-3.51101734 285.799062,-3.79797549 300.466655,10.5499319 C315.134248,24.8978393 315.134248,48.7153656 300.754255,63.3502311 Z",
    id: "Path"
  }))));
};

var ArrowForward = function ArrowForward(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: props.color,
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "ArrowForward",
    transform: "translate(620.500000, 620.500000) rotate(180.000000) translate(-620.500000, -620.500000) translate(206.000000, 345.000000)"
  }, React.createElement("path", {
    d: "M300.754255,63.3502311 L126.181139,238.107743 L791.399618,238.107743 C811.819208,238.107743 828.5,254.751316 828.5,275.412302 C828.5,296.073289 811.819208,312.716862 791.399618,312.716862 L126.181139,312.716862 L301.041855,487.474374 C315.421848,502.109239 315.134248,525.639807 300.754255,540.274673 C286.086662,554.62258 262.791073,554.62258 248.12348,539.987715 L11.1411949,301.812452 C7.97759639,298.368954 5.38919764,294.638498 3.37599861,290.047168 C1.36279958,285.455838 0.5,280.577549 0.5,275.699261 C0.5,265.942684 4.23879819,256.760023 11.1411949,249.586069 L248.12348,11.4108064 C262.215874,-3.51101734 285.799062,-3.79797549 300.466655,10.5499319 C315.134248,24.8978393 315.134248,48.7153656 300.754255,63.3502311 Z",
    id: "Path"
  }))));
};

var ArrowDown = function ArrowDown(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: props.color,
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "ArrowDown",
    transform: "translate(620.500000, 620.500000) rotate(-90.000000) translate(-620.500000, -620.500000) translate(206.000000, 345.000000)"
  }, React.createElement("path", {
    d: "M300.754255,63.3502311 L126.181139,238.107743 L791.399618,238.107743 C811.819208,238.107743 828.5,254.751316 828.5,275.412302 C828.5,296.073289 811.819208,312.716862 791.399618,312.716862 L126.181139,312.716862 L301.041855,487.474374 C315.421848,502.109239 315.134248,525.639807 300.754255,540.274673 C286.086662,554.62258 262.791073,554.62258 248.12348,539.987715 L11.1411949,301.812452 C7.97759639,298.368954 5.38919764,294.638498 3.37599861,290.047168 C1.36279958,285.455838 0.5,280.577549 0.5,275.699261 C0.5,265.942684 4.23879819,256.760023 11.1411949,249.586069 L248.12348,11.4108064 C262.215874,-3.51101734 285.799062,-3.79797549 300.466655,10.5499319 C315.134248,24.8978393 315.134248,48.7153656 300.754255,63.3502311 Z",
    id: "Path"
  }))));
};

var CheckMark = function CheckMark(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "_ionicons_svg_ios-checkmark",
    transform: "translate(157.000000, -1030.000000)",
    fill: props.color
  }, React.createElement("path", {
    d: "M595.120147,1918.62015 L343.120147,1918.62015 C318.819618,1918.62015 299.120147,1898.92068 299.120147,1874.62015 C299.120147,1850.31962 318.819618,1830.62015 343.120147,1830.62015 L551.120147,1830.62015 L551.120147,1241.62015 C551.120147,1217.31962 570.819618,1197.62015 595.120147,1197.62015 C619.420676,1197.62015 639.120147,1217.31962 639.120147,1241.62015 L639.120147,1874.62015 C639.120147,1898.92068 619.420676,1918.62015 595.120147,1918.62015 Z",
    id: "Combined-Shape",
    transform: "translate(469.120147, 1558.120147) rotate(45.000000) translate(-469.120147, -1558.120147) "
  })));
};

var Menu = function Menu(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: props.color,
    fillRule: "evenodd"
  }, React.createElement("rect", {
    id: "Rectangle",
    x: "202",
    y: "350",
    width: "837",
    height: "70",
    rx: "35"
  }), React.createElement("rect", {
    id: "Rectangle",
    x: "202",
    y: "585",
    width: "837",
    height: "70",
    rx: "35"
  }), React.createElement("rect", {
    id: "Rectangle",
    x: "202",
    y: "820",
    width: "837",
    height: "70",
    rx: "35"
  })));
};

var Cycling = function Cycling(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group-2",
    transform: "translate(80.000000, 280.000000)",
    stroke: props.color
  }, React.createElement("g", {
    id: "Group"
  }, React.createElement("ellipse", {
    id: "Oval",
    strokeWidth: "54",
    cx: "207.656422",
    cy: "473.378049",
    rx: "207.656422",
    ry: "207.621951"
  }), React.createElement("ellipse", {
    id: "Oval",
    strokeWidth: "54",
    cx: "873.343578",
    cy: "473.378049",
    rx: "207.656422",
    ry: "207.621951"
  }), React.createElement("path", {
    d: "M620.151783,492.087954 L620.299683,491.860627 L868.601479,491.860627 C882.740546,491.860627 894.202525,480.398649 894.202525,466.259582 C894.202525,464.015837 893.913983,461.810694 893.34391,459.657156 C892.879943,457.444654 892.009263,455.326052 890.750811,453.388527 L890.592154,453.143619 C890.265478,452.597104 889.918501,452.062939 889.541577,451.52678 L683.254244,133.924873 L705.607381,50.5156793 L750.027499,50.5156794 C764.11861,50.5156794 775.541712,39.0925767 775.541712,25.0014656 C775.541712,24.3470742 775.514392,23.6929682 775.459823,23.0408561 C774.377008,10.1009996 763.009387,0.488972425 750.069536,1.57180163 C689.426918,6.64641204 651.649321,11.4408659 636.791713,15.9415603 C625.861316,19.2526167 617.531222,25.3841357 611.781407,34.3454015 C610.695798,36.0373564 610.118711,38.0053914 610.118711,40.0156794 C610.118711,45.8146691 614.819721,50.5156791 620.618711,50.5156791 L667.331721,50.5156792 L648.940538,119.141115 L325.192562,119.141115 L334.941225,82.7646482 C334.9415,82.7636219 334.9415,82.7636219 334.941775,82.7625955 C338.600937,69.1041528 330.494917,55.065461 316.836475,51.4062998 C303.176522,47.746734 289.136121,55.8529631 285.475421,69.5126121 L181.671892,456.84835 C181.671617,456.849376 181.671617,456.849376 181.671342,456.850403 C178.012181,470.508845 186.1182,484.547537 199.776643,488.206698 C213.436596,491.866264 227.476997,483.760035 231.137696,470.100386 L297.455527,222.639955 L516.597977,441.746028 L516.499463,442.039662 C514.520764,447.937439 513.5,454.149095 513.5,460.5 C513.5,492.532515 539.467485,518.5 571.5,518.5 C591.36713,518.5 609.516929,508.433963 620.151783,492.087954 Z M547.174121,407.832308 L546.857419,407.978832 L546.610651,407.732104 L310.987133,172.147699 L314.968183,157.292683 L638.716159,157.292683 L572.997416,402.517654 L572.606356,402.510339 C572.237997,402.503449 571.869201,402.5 571.5,402.5 C562.9859,402.5 554.732396,404.335442 547.174121,407.832308 Z M607.847884,415.298524 L670.378012,181.971648 L838.399133,440.658537 L626.018669,440.658536 L625.897712,440.332406 C622.294238,430.616536 616.126775,422.040515 608.098914,415.502953 L607.847884,415.298524 Z",
    id: "Combined-Shape",
    fill: props.color
  }), React.createElement("path", {
    d: "M310.411973,69 L200.511211,69.0005248 C165.112002,69.0005248 149,86.2873067 149,122.984432 C149,147.449183 171.899968,161.077963 217.699903,163.870774",
    id: "Path-2",
    strokeWidth: "38",
    strokeLinecap: "round"
  })))));
}; // import React from 'react';
//
// export const Cycling = (props) => {
//
// 	return (
// 		<svg
// 		width={ props.size }
// 		height={ props.size }
// 		viewBox="0 0 1240 1240"
// 		xmlns="http://www.w3.org/2000/svg" >
// 		<g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
// 				<g id="Group-2" transform="translate(80.000000, 280.000000)">
// 						<g id="Group" stroke={ props.color }>
// 								<ellipse id="Oval" stroke-width="44" cx="207.656422" cy="473.378049" rx="207.656422" ry="207.621951"></ellipse>
// 								<ellipse id="Oval" stroke-width="44" cx="873.343578" cy="473.378049" rx="207.656422" ry="207.621951"></ellipse>
// 								<path d="M667.331721,50.5156792 L648.940538,119.141115 L325.192562,119.141115 L334.941225,82.7646482 C334.9415,82.7636219 334.9415,82.7636219 334.941775,82.7625955 C338.600937,69.1041528 330.494917,55.065461 316.836475,51.4062998 C303.176522,47.746734 289.136121,55.8529631 285.475421,69.5126121 L181.671892,456.84835 C181.671617,456.849376 181.671617,456.849376 181.671342,456.850403 C178.012181,470.508845 186.1182,484.547537 199.776643,488.206698 C213.436596,491.866264 227.476997,483.760035 231.137696,470.100386 L297.455527,222.639955 L558.734343,483.875398 C560.361376,485.502162 562.197943,486.853277 564.226411,487.923733 C568.279379,490.482387 572.974203,491.860627 577.873822,491.860627 L868.601479,491.860627 C882.740546,491.860627 894.202525,480.398649 894.202525,466.259582 C894.202525,464.015837 893.913983,461.810694 893.34391,459.657156 C892.879943,457.444654 892.009263,455.326052 890.750811,453.388527 L890.592154,453.143619 C890.265478,452.597104 889.918501,452.062939 889.541577,451.52678 L683.254244,133.924873 L705.607381,50.5156793 L750.027499,50.5156794 C764.11861,50.5156794 775.541712,39.0925767 775.541712,25.0014656 C775.541712,24.3470742 775.514392,23.6929682 775.459823,23.0408561 C774.377008,10.1009996 763.009387,0.488972425 750.069536,1.57180163 C689.426918,6.64641204 651.649321,11.4408659 636.791713,15.9415603 C625.861316,19.2526167 617.531222,25.3841357 611.781407,34.3454015 C610.695798,36.0373564 610.118711,38.0053914 610.118711,40.0156794 C610.118711,45.8146691 614.819721,50.5156791 620.618711,50.5156791 L667.331721,50.5156792 Z M314.968183,157.292683 L638.716159,157.292683 L566.319111,427.437293 L310.987133,172.147699 L314.968183,157.292683 Z M601.051561,440.658537 L670.378012,181.971648 L838.399133,440.658537 L601.051561,440.658537 Z" id="Combined-Shape" fill={ props.color }></path>
// 								<path d="M308.551381,66.4390244 L198.650618,66.4395492 C163.251409,66.4395492 147.139407,83.7263311 147.139407,120.423457 C147.139407,144.888207 170.039375,158.516988 215.83931,161.309799" id="Path-2" stroke-width="30" stroke-linecap="round"></path>
// 						</g>
// 						<circle id="Oval" fill={ props.color } cx="571.5" cy="460.5" r="58.5"></circle>
// 				</g>
// 		</g>
// 		</svg>
// 	)
// }
//
// export default Cycling;


var LineChart = function LineChart(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: props.color,
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M280,871 L995,871 C1014.32997,871 1030,886.670034 1030,906 C1030,925.329966 1014.32997,941 995,941 L245,941 C225.670034,941 210,925.329966 210,906 L210,295 C210,275.670034 225.670034,260 245,260 C264.329966,260 280,275.670034 280,295 L280,871 Z M536.178132,513.675861 C545.443201,513.594836 554.722445,517.170385 561.666829,524.361505 L661.172259,627.402395 L890.103843,406.325735 C904.008657,392.898012 926.166056,393.284771 939.593779,407.189585 C953.021501,421.094399 952.634743,443.251798 938.729928,456.679521 L684.802979,701.893926 C677.964226,708.498033 669.12923,711.760512 660.318359,711.716629 C651.097399,711.762555 641.873496,708.186898 634.962233,701.030076 L535.328855,597.856692 L376.036031,751.683984 C362.131217,765.111707 339.973818,764.724948 326.546095,750.820134 C313.118372,736.91532 313.505131,714.757921 327.409945,701.330198 L511.560934,523.497655 C518.433988,516.860424 527.32336,513.598426 536.178129,513.675861 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Star = function Star(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("polygon", {
    id: "Star",
    stroke: props.color,
    strokeWidth: "70",
    fill: props.color,
    strokeLinejoin: "round",
    points: "620 780 384.885899 943.606798 467.830957 669.442719 239.577393 496.393202 525.95436 490.557281 620 220 714.04564 490.557281 1000.42261 496.393202 772.169043 669.442719 855.114101 943.606798"
  })));
};

var StarOutlined = function StarOutlined(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("polygon", {
    id: "Star",
    stroke: props.color,
    strokeWidth: "70",
    strokeLinejoin: "round",
    points: "620 780 384.885899 943.606798 467.830957 669.442719 239.577393 496.393202 525.95436 490.557281 620 220 714.04564 490.557281 1000.42261 496.393202 772.169043 669.442719 855.114101 943.606798"
  })));
};

var Star$1 = function Star(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(220.000000, 220.000000)"
  }, React.createElement("polygon", {
    id: "Star",
    stroke: props.color,
    strokeWidth: "70",
    strokeLinejoin: "round",
    points: "400 560 164.885899 723.606798 247.830957 449.442719 19.5773935 276.393202 305.95436 270.557281 400 0 494.04564 270.557281 780.422607 276.393202 552.169043 449.442719 635.114101 723.606798"
  }), React.createElement("path", {
    d: "M400,525.056918 L442.63587,554.910876 L411.638085,599.1803 L377.772424,575.467309 L164.885899,723.606798 L247.830957,449.442719 L19.5773935,276.393202 L305.95436,270.557281 L400,6.82121026e-13 C400,310.139996 400,473.486479 400,490.039448 L400,525.056918 Z",
    id: "Combined-Shape",
    fill: props.color
  }))));
};

var Bookmark = function Bookmark(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M464,272 L775.000001,272 C807.032516,272 833.000001,297.967485 833.000001,330 L833.000001,968.000002 L619.5,771.234177 L406,968.000002 L406,330 C406,297.967485 431.967485,272 464,272 Z",
    id: "Rectangle",
    stroke: props.color,
    strokeWidth: "70",
    fill: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var BookmarkOutlined = function BookmarkOutlined(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M464,272 L775.000001,272 C807.032516,272 833.000001,297.967485 833.000001,330 L833.000001,968.000002 L619.5,771.234177 L406,968.000002 L406,330 C406,297.967485 431.967485,272 464,272 Z",
    id: "Rectangle",
    stroke: props.color,
    strokeWidth: "70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var CloudUpload = function CloudUpload(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M647.805422,792 L647.805422,558.213356 L780.26217,690.301315 C791.354606,701.181707 809.407004,701.181707 820.281942,690.083707 C831.15688,678.985707 830.939382,661.141864 819.629446,650.47908 L639.105472,471.170219 C633.668002,465.947631 626.708042,463.118729 619.313084,463.118729 C615.615605,463.118729 611.918126,463.771553 608.438146,465.294808 C604.958166,466.818063 602.130682,468.776533 599.520696,471.170219 L418.996722,650.47908 C407.904285,661.57708 407.904285,679.203315 418.779223,690.301315 C429.87166,701.181707 447.706559,701.399315 458.798996,690.518923 L591.255743,558.213356 L591.255743,792 L404.319958,792 C397.802969,792.661276 391.190939,793 384.5,793 C277.080616,793 190,705.695526 190,598 C190,512.754211 244.559708,440.284284 320.579424,413.775005 C320.195415,408.566978 320,403.306364 320,398 C320,281.467918 414.24406,187 530.5,187 C608.638737,187 676.833509,229.676305 713.152002,293.044508 C734.473934,278.502293 760.244058,270 788,270 C861.453872,270 921,329.546128 921,403 C921,418.208301 918.447384,432.820407 913.747219,446.431248 C991.221523,464.237511 1049,533.621312 1049,616.5 C1049,712.873689 970.873689,791 874.5,791 C874.333279,791 874.166612,790.999766 874,790.999299 L874,792 L647.805422,792 Z M647.805422,793 L647.805422,1061.54029 C647.805422,1076.99045 635.190494,1089.6117 619.530583,1089.6117 C603.870672,1089.6117 591.255743,1076.99045 591.255743,1061.54029 L591.255743,793.012089 L647.805422,793 Z",
    id: "Combined-Shape",
    fill: props.color
  }), React.createElement("g", {
    id: "Group",
    transform: "translate(590.000000, 793.000000)"
  }, React.createElement("g", {
    id: "_ionicons_svg_ios-arrow-round-back",
    transform: "translate(0.500000, 0.000000)"
  })));
};

var CloudDownload = function CloudDownload(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M647.805422,792 L647.805422,1026.78664 L780.26217,894.698685 C791.354606,883.818293 809.407004,883.818293 820.281942,894.916293 C831.15688,906.014293 830.939382,923.858136 819.629446,934.52092 L639.105472,1113.82978 C633.668002,1119.05237 626.708042,1121.88127 619.313084,1121.88127 C615.615605,1121.88127 611.918126,1121.22845 608.438146,1119.70519 C604.958166,1118.18194 602.130682,1116.22347 599.520696,1113.82978 L418.996722,934.52092 C407.904285,923.42292 407.904285,905.796685 418.779223,894.698685 C429.87166,883.818293 447.706559,883.600685 458.798996,894.481077 L591.255743,1026.78664 L591.255743,792 L404.319958,792 C397.802969,792.661276 391.190939,793 384.5,793 C277.080616,793 190,705.695526 190,598 C190,512.754211 244.559708,440.284284 320.579424,413.775005 C320.195415,408.566978 320,403.306364 320,398 C320,281.467918 414.24406,187 530.5,187 C608.638737,187 676.833509,229.676305 713.152002,293.044508 C734.473934,278.502293 760.244058,270 788,270 C861.453872,270 921,329.546128 921,403 C921,418.208301 918.447384,432.820407 913.747219,446.431248 C991.221523,464.237511 1049,533.621312 1049,616.5 C1049,712.873689 970.873689,791 874.5,791 C874.333279,791 874.166612,790.999766 874,790.999299 L874,792 L647.805422,792 Z M647.805422,792 L647.805422,523.459708 C647.805422,508.009552 635.190494,495.388297 619.530583,495.388297 C603.870672,495.388297 591.255743,508.009552 591.255743,523.459708 L591.255743,791.987911 L647.805422,792 Z",
    id: "Combined-Shape",
    fill: props.color
  }), React.createElement("g", {
    id: "Group",
    transform: "translate(410.000000, 791.000000)"
  }, React.createElement("g", {
    id: "_ionicons_svg_ios-arrow-round-back",
    transform: "translate(0.500000, 0.000000)"
  }, React.createElement("g", {
    id: "Group-2",
    transform: "translate(209.000000, 165.500000) scale(1, -1) translate(-209.000000, -165.500000) "
  }))));
};

var Cloud = function Cloud(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M383.25314,893.665684 C290.541466,888.331894 217,811.266389 217,716.980198 C217,643.319541 261.885625,580.169434 325.731093,553.522306 C325.238383,547.914642 324.986799,542.237596 324.986799,536.50165 C324.986799,430.738209 410.521837,345 516.034653,345 C585.541329,345 646.37859,382.206345 679.805784,437.83387 C700.637342,426.66468 724.44854,420.330033 749.739274,420.330033 C831.59316,420.330033 897.948845,486.685718 897.948845,568.539604 C897.948845,572.483823 897.794774,576.392056 897.492321,580.258614 C969.561359,595.1033 1023.74917,658.910822 1023.74917,735.374587 C1023.74917,821.80455 954.515253,892.064063 868.481223,893.719314 C867.968067,893.958711 867.395687,894.092409 866.792079,894.092409 L384.072607,894.092409 C383.733595,894.092409 383.433983,893.923712 383.25314,893.665684 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Cloud$1 = function Cloud(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M383.25314,893.665684 C290.541466,888.331894 217,811.266389 217,716.980198 C217,643.319541 261.885625,580.169434 325.731093,553.522306 C325.238383,547.914642 324.986799,542.237596 324.986799,536.50165 C324.986799,430.738209 410.521837,345 516.034653,345 C585.541329,345 646.37859,382.206345 679.805784,437.83387 C700.637342,426.66468 724.44854,420.330033 749.739274,420.330033 C831.59316,420.330033 897.948845,486.685718 897.948845,568.539604 C897.948845,572.483823 897.794774,576.392056 897.492321,580.258614 C969.561359,595.1033 1023.74917,658.910822 1023.74917,735.374587 C1023.74917,821.80455 954.515253,892.064063 868.481223,893.719314 C867.968067,893.958711 867.395687,894.092409 866.792079,894.092409 L384.072607,894.092409 C383.733595,894.092409 383.433983,893.923712 383.25314,893.665684 Z",
    id: "Combined-Shape",
    stroke: props.color,
    strokeWidth: "70"
  })));
};

var Coffee = function Coffee(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M711,498 L885,498 C909.300529,498 929,517.699471 929,542 L929,718 C929,742.300529 909.300529,762 885,762 L789,762 L789,878 C789,933.228475 744.228475,978 689,978 L412,978 C356.771525,978 312,933.228475 312,878 L312,542 C312,517.699471 331.699471,498 356,498 L711,498 Z M789,567 L789,693 L849,693 C858.388841,693 866,685.388841 866,676 L866,584 C866,574.611159 858.388841,567 849,567 L789,567 Z M405,292 C424.329966,292 440,307.670034 440,327 L440,423 C440,442.329966 424.329966,458 405,458 C385.670034,458 370,442.329966 370,423 L370,327 C370,307.670034 385.670034,292 405,292 Z M545,262 C564.329966,262 580,277.670034 580,297 L580,418 C580,437.329966 564.329966,453 545,453 C525.670034,453 510,437.329966 510,418 L510,297 C510,277.670034 525.670034,262 545,262 Z M685,281 C704.329966,281 720,296.670034 720,316 L720,418 C720,437.329966 704.329966,453 685,453 C665.670034,453 650,437.329966 650,418 L650,316 C650,296.670034 665.670034,281 685,281 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Lock = function Lock(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M423.5,563 L816.5,563 C842.181241,563 863,583.818759 863,609.5 L863,907.5 C863,933.181241 842.181241,954 816.5,954 L423.5,954 C397.818759,954 377,933.181241 377,907.5 L377,609.5 C377,583.818759 397.818759,563 423.5,563 Z M598,749.056471 L598,832 C598,844.150264 607.849736,854 620,854 C632.150264,854 642,844.150264 642,832 L642.000007,749.609948 C656.286351,741.936012 666,726.852378 666,709.5 C666,684.371044 645.628956,664 620.5,664 C595.371044,664 575,684.371044 575,709.5 C575,726.444413 584.26227,741.225507 598,749.056471 Z",
    id: "Combined-Shape",
    fill: props.color
  }), React.createElement("path", {
    d: "M499,608.220877 C499,552.991223 499,513.646151 499,490.185659 C499,376.196017 559.325022,322 619.650044,322 C679.975066,322 740.300088,364.013562 740.300088,490.185659 C740.300088,511.634194 740.300088,550.979267 740.300088,608.220877",
    id: "Path-5",
    stroke: props.color,
    strokeWidth: "70"
  })));
};

var UnLock = function UnLock(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M423.5,563 L816.5,563 C842.181241,563 863,583.818759 863,609.5 L863,907.5 C863,933.181241 842.181241,954 816.5,954 L423.5,954 C397.818759,954 377,933.181241 377,907.5 L377,609.5 C377,583.818759 397.818759,563 423.5,563 Z M598,749.056471 L598,832 C598,844.150264 607.849736,854 620,854 C632.150264,854 642,844.150264 642,832 L642.000007,749.609948 C656.286351,741.936012 666,726.852378 666,709.5 C666,684.371044 645.628956,664 620.5,664 C595.371044,664 575,684.371044 575,709.5 C575,726.444413 584.26227,741.225507 598,749.056471 Z",
    id: "Combined-Shape",
    fill: props.color
  }), React.createElement("path", {
    d: "M499,620 C499,508.250931 499,440.646151 499,417.185659 C499,303.196017 559.325022,249 619.650044,249 C679.975066,249 740.300088,291.013562 740.300088,417.185659",
    id: "Path-5",
    stroke: props.color,
    strokeWidth: "70"
  })));
};

var Time = function Time(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M620,271 C427.211058,271 271,427.211058 271,620 C271,812.788942 427.211058,969 620,969 C812.788942,969 969,812.788942 969,620 C969,427.211058 812.788942,271 620,271 Z M650,623.367816 C650,638.015517 638.009677,650 623.354839,650 L440.645161,650 C425.990323,650 414,638.015517 414,623.367816 C414,608.720115 425.990323,596.735632 440.645161,596.735632 L596.709677,596.735632 L596.709677,354.750109 C596.709677,340.102408 608.7,328.117925 623.354839,328.117925 C638.009677,328.117925 650,340.102408 650,354.750109 L650,623.367816 Z",
    id: "Shape",
    fill: props.color,
    fillRule: "nonzero"
  })));
};

var Flash = function Flash(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(374.000000, 204.000000)",
    fill: props.color
  }, React.createElement("polygon", {
    id: "Triangle",
    points: "328.756344 0.421765235 293 445 -5.68434189e-14 445"
  }), React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(328.378172, 610.289117) scale(-1, -1) translate(-328.378172, -610.289117) ",
    points: "492.756344 388 457 832.578235 164 832.578235"
  }))));
};

var Loader = function Loader(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M620,438.501515 L620,257.003029 C620.499763,257.00101 620.999763,257 621.5,257 C822.088814,257 984.729711,419.474343 984.999663,620 L984.999688,620 L620,620 L620,438.501515 L620,170.00101 C620.333248,170.000363 620.666582,170 621,170 C869.528137,170 1071,371.471863 1071,620 L620,620 L620,438.501515 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Time$1 = function Time(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M585,585 L585,289 C585,269.670034 600.670034,254 620,254 C639.329966,254 655,269.670034 655,289 L655,585 L951,585 C970.329966,585 986,600.670034 986,620 C986,639.329966 970.329966,655 951,655 L655,655 L655,951 C655,970.329966 639.329966,986 620,986 C600.670034,986 585,970.329966 585,951 L585,655 L289,655 C269.670034,655 254,639.329966 254,620 C254,600.670034 269.670034,585 289,585 L585,585 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Time$2 = function Time(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    fill: props.color,
    id: "Combined-Shape",
    x: "254",
    y: "585",
    width: "732",
    height: "70",
    rx: "35"
  })));
};

var Time$3 = function Time(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M542.531227,715.392159 C499.626617,683.49195 471,626.054597 471,560.5 C471,494.945403 499.626617,437.50805 542.531227,405.607841 L322.886325,405.607843 C322.935876,406.578925 322.960929,407.555892 322.960929,408.538235 C322.960929,442.524864 292.972754,470.076471 255.980465,470.076471 C254.911246,470.076471 253.847879,470.053453 252.790919,470.007928 L252.790919,650.992072 C253.847879,650.946547 254.911246,650.923529 255.980465,650.923529 C292.972754,650.923529 322.960929,678.475136 322.960929,712.461765 C322.960929,713.444108 322.935876,714.421075 322.886325,715.392157 L542.531225,715.392157 Z M698.468775,715.392157 L916.291077,715.392157 C916.241526,714.421075 916.216473,713.444108 916.216473,712.461765 C916.216473,678.475136 946.204649,650.923529 983.196938,650.923529 C984.882927,650.923529 986.554367,650.980761 988.209081,651.093224 L988.209081,469.906776 C986.554367,470.019239 984.882927,470.076471 983.196938,470.076471 C946.204649,470.076471 916.216473,442.524864 916.216473,408.538235 C916.216473,407.555892 916.241526,406.578925 916.291077,405.607843 L698.468775,405.607843 C741.373383,437.50805 770,494.945403 770,560.5 C770,626.054597 741.373383,683.49195 698.468773,715.392159 Z M1052,715.392157 L1052,774 L189,774 L189,715.392157 L189,405.607843 L189,347 L1052,347 L1052,405.607843 L1052,715.392157 Z M189,864 L1052,864 L1052,899 L189,899 L189,864 Z M189,804 L1052,804 L1052,839 L189,839 L189,804 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Card = function Card(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M1042.5,471.5 L1042.5,427 C1042.5,402.975613 1023.02439,383.5 999,383.5 L242,383.5 C217.975613,383.5 198.5,402.975613 198.5,427 L198.5,471.5 L1042.5,471.5 Z M1042.5,560.5 L198.5,560.5 L198.5,814 C198.5,838.024387 217.975613,857.5 242,857.5 L999,857.5 C1023.02439,857.5 1042.5,838.024387 1042.5,814 L1042.5,560.5 Z M284.5,751.5 L692.147059,751.5 C707.058747,751.5 719.147059,763.588312 719.147059,778.5 C719.147059,793.411688 707.058747,805.5 692.147059,805.5 L284.5,805.5 C269.588312,805.5 257.5,793.411688 257.5,778.5 C257.5,763.588312 269.588312,751.5 284.5,751.5 Z M804.5,751.5 C819.411688,751.5 831.5,763.588312 831.5,778.5 C831.5,793.411688 819.411688,805.5 804.5,805.5 L784.470588,805.5 C769.5589,805.5 757.470588,793.411688 757.470588,778.5 C757.470588,763.588312 769.5589,751.5 784.470588,751.5 L804.5,751.5 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Cart = function Cart(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group-3",
    transform: "translate(240.000000, 284.000000)"
  }, React.createElement("g", {
    id: "Group"
  }, React.createElement("path", {
    d: "M170.644857,56.769697 L734.152009,56.769697 C748.787555,56.769697 760.652009,68.6341511 760.652009,83.269697 C760.652009,85.1006791 760.462247,86.9267314 760.085763,88.7185895 L697.457622,386.794347 C694.880091,399.061985 684.059362,407.845455 671.523868,407.845455 L232.625169,407.845455 C220.068962,407.845455 209.236321,399.03359 206.680125,386.740331 L144.699813,88.6645735 C141.720305,74.3355214 150.920928,60.3041611 165.249981,57.324653 C167.024562,56.9556559 168.832318,56.769697 170.644857,56.769697 Z",
    id: "Rectangle",
    fill: props.color
  }), React.createElement("polyline", {
    id: "Path-6",
    stroke: props.color,
    strokeWidth: "50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "200.135802 231.765286 148.784301 0 0 1.00913995e-16"
  }), React.createElement("polyline", {
    id: "Path-6",
    stroke: props.color,
    strokeWidth: "50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "701.648534 493 172.896286 493 241.945131 375.15164"
  })), React.createElement("g", {
    id: "Group-2",
    transform: "translate(206.000000, 541.000000)",
    fill: props.color
  }, React.createElement("ellipse", {
    id: "Oval",
    cx: "65.5769231",
    cy: "65.5",
    rx: "65.5769231",
    ry: "65.5"
  }), React.createElement("ellipse", {
    id: "Oval",
    cx: "399.423077",
    cy: "65.5",
    rx: "65.5769231",
    ry: "65.5"
  })))));
};

var Card$1 = function Card(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M312.5,322 L927.5,322 C942.135546,322 954,333.864454 954,348.5 L954,732.679878 C954,747.315424 942.135546,759.179878 927.5,759.179878 L407.444212,759.179878 L286,917 L286,348.5 C286,333.864454 297.864454,322 312.5,322 Z M522,567 C539.120827,567 553,553.120827 553,536 C553,518.879173 539.120827,505 522,505 C504.879173,505 491,518.879173 491,536 C491,553.120827 504.879173,567 522,567 Z M621,567 C638.120827,567 652,553.120827 652,536 C652,518.879173 638.120827,505 621,505 C603.879173,505 590,518.879173 590,536 C590,553.120827 603.879173,567 621,567 Z M719,567 C736.120827,567 750,553.120827 750,536 C750,518.879173 736.120827,505 719,505 C701.879173,505 688,518.879173 688,536 C688,553.120827 701.879173,567 719,567 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Code = function Code(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Artboard",
    fill: props.color
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(256.000000, 404.000000)"
  }, React.createElement("path", {
    d: "M721.532581,197.801844 C731.75503,208.909573 731.479314,226.206178 720.705433,236.98006 L534.951738,422.733755 C523.894899,433.790594 505.968221,433.790594 494.911383,422.733755 C483.854544,411.676916 483.854544,393.750239 494.911383,382.6934 L660.796375,216.808408 L493.294567,49.3066 C482.237729,38.2497613 482.237729,20.3230838 493.294567,9.2662451 C504.351406,-1.79059359 522.278084,-1.79059359 533.334922,9.2662451 L719.088617,195.01994 C719.974202,195.905524 720.788856,196.835179 721.532581,197.801844 Z M7.46741931,197.801844 C8.21114395,196.835179 9.02579841,195.905524 9.91138268,195.01994 L195.665078,9.2662451 C206.721916,-1.79059359 224.648594,-1.79059359 235.705433,9.2662451 C246.762271,20.3230838 246.762271,38.2497613 235.705433,49.3066 L68.2036249,216.808408 L234.088617,382.6934 C245.145456,393.750239 245.145456,411.676916 234.088617,422.733755 C223.031779,433.790594 205.105101,433.790594 194.048262,422.733755 L8.29456745,236.98006 C-2.47931399,226.206178 -2.75503004,208.909573 7.46741931,197.801844 Z",
    id: "Combined-Shape"
  })))));
};

var Bell = function Bell(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(347.000000, 281.000000)"
  }, React.createElement("path", {
    d: "M87.5,550 L457.5,550 L457.5,277 C457.5,174.827321 374.672679,92 272.5,92 C170.327321,92 87.5,174.827321 87.5,277 L87.5,550 Z",
    id: "Combined-Shape",
    stroke: props.color,
    strokeWidth: "70"
  }), React.createElement("path", {
    d: "M44,507 L503,507 C527.024387,507 546.5,526.475613 546.5,550.5 L546.5,585 L0.5,585 L0.5,550.5 C0.5,526.475613 19.9756134,507 44,507 Z",
    id: "Rectangle",
    fill: props.color
  }), React.createElement("path", {
    d: "M200.5,609 L342.5,609 L342.5,609 C342.5,647.659932 311.159932,679 272.5,679 L270.5,679 C231.840068,679 200.5,647.659932 200.5,609 Z",
    id: "Rectangle",
    fill: props.color
  }), React.createElement("path", {
    d: "M233.5,0 L311.5,0 L311.5,31 C311.5,52.5391052 294.039105,70 272.5,70 L272.5,70 C250.960895,70 233.5,52.5391052 233.5,31 L233.5,0 Z",
    id: "Rectangle",
    fill: props.color,
    transform: "translate(272.500000, 35.000000) scale(1, -1) translate(-272.500000, -35.000000) "
  }))));
};

var Bell$1 = function Bell(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(347.000000, 281.000000)"
  }, React.createElement("path", {
    d: "M87.5,550 L457.5,550 L457.5,277 C457.5,174.827321 374.672679,92 272.5,92 C170.327321,92 87.5,174.827321 87.5,277 L87.5,550 Z",
    id: "Combined-Shape",
    stroke: props.color,
    fill: props.color,
    strokeWidth: "70"
  }), React.createElement("path", {
    d: "M44,507 L503,507 C527.024387,507 546.5,526.475613 546.5,550.5 L546.5,585 L0.5,585 L0.5,550.5 C0.5,526.475613 19.9756134,507 44,507 Z",
    id: "Rectangle",
    fill: props.color
  }), React.createElement("path", {
    d: "M200.5,609 L342.5,609 L342.5,609 C342.5,647.659932 311.159932,679 272.5,679 L270.5,679 C231.840068,679 200.5,647.659932 200.5,609 Z",
    id: "Rectangle",
    fill: props.color
  }), React.createElement("path", {
    d: "M233.5,0 L311.5,0 L311.5,31 C311.5,52.5391052 294.039105,70 272.5,70 L272.5,70 C250.960895,70 233.5,52.5391052 233.5,31 L233.5,0 Z",
    id: "Rectangle",
    fill: props.color,
    transform: "translate(272.500000, 35.000000) scale(1, -1) translate(-272.500000, -35.000000) "
  }))));
};

var Cart$1 = function Cart(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M889,912.753932 C889,909.628434 889,890.04379 889,854 C889,745.752189 768.564598,658 620,658 C471.435402,658 351,745.752189 351,854 C351,886.737451 351,906.322095 351,912.753932",
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70"
  }), React.createElement("circle", {
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70",
    cx: "620.5",
    cy: "492.5",
    r: "165.5"
  })));
};

var Refresh = function Refresh(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M620,920 C785.685425,920 920,785.685425 920,620 C920,454.314575 785.685425,320 620,320 C454.314575,320 320,454.314575 320,620",
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70",
    strokeLinecap: "round",
    transform: "translate(620.000000, 620.000000) rotate(180.000000) translate(-620.000000, -620.000000) "
  }), React.createElement("path", {
    d: "M707.077709,255.188418 L799.984734,378.270374 C803.977546,383.559997 802.926273,391.084897 797.636651,395.077709 C795.554195,396.649627 793.016153,397.5 790.407025,397.5 L604.592975,397.5 C597.965558,397.5 592.592975,392.127417 592.592975,385.5 C592.592975,382.890872 593.443348,380.35283 595.015266,378.270374 L687.922291,255.188418 C691.915103,249.898795 699.440003,248.847523 704.729626,252.840335 C705.617356,253.510428 706.407616,254.300687 707.077709,255.188418 Z",
    id: "Triangle",
    fill: props.color,
    transform: "translate(697.500000, 320.000000) rotate(90.000000) translate(-697.500000, -320.000000) "
  })));
};

var Settings = function Settings(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M689.902558,372.770185 C731.609003,384.616272 769.003744,406.710379 799.192269,436.157997 L853.803446,404.628222 C858.586372,401.866798 864.702276,403.50555 867.4637,408.288476 L927.4637,512.211524 C930.225123,516.99445 928.586372,523.110355 923.803446,525.871778 L869.125017,557.440384 C874.204601,577.619228 876.902558,598.744543 876.902558,620.5 C876.902558,642.255457 874.204601,663.380772 869.125017,683.559616 L923.803446,715.128222 C928.586372,717.889645 930.225123,724.00555 927.4637,728.788476 L867.4637,832.711524 C864.702276,837.49445 858.586372,839.133202 853.803446,836.371778 L799.192268,804.842 C769.003744,834.289621 731.609003,856.383728 689.902558,868.229815 L689.902558,931 C689.902558,936.522847 685.425405,941 679.902558,941 L559.902558,941 C554.37971,941 549.902558,936.522847 549.902558,931 L549.902558,868.511654 C507.965378,856.784111 470.350124,834.70559 439.985125,805.204418 L386.00167,836.371778 C381.218744,839.133202 375.102839,837.49445 372.341416,832.711524 L312.341416,728.788476 C309.579992,724.00555 311.218744,717.889645 316.00167,715.128222 L369.807467,684.06343 C364.645626,663.732496 361.902558,642.436587 361.902558,620.5 C361.902558,598.563413 364.645626,577.267504 369.807467,556.93657 L316.00167,525.871778 C311.218744,523.110355 309.579992,516.99445 312.341416,512.211524 L372.341416,408.288476 C375.102839,403.50555 381.218744,401.866798 386.00167,404.628222 L439.985126,435.795585 C470.350124,406.29441 507.965378,384.215889 549.902558,372.488346 L549.902558,310 C549.902558,304.477153 554.37971,300 559.902558,300 L679.902558,300 C685.425405,300 689.902558,304.477153 689.902558,310 L689.902558,372.770185 Z M619.902558,502 C554.180672,502 500.902558,555.278115 500.902558,621 C500.902558,686.721885 554.180672,740 619.902558,740 C685.624443,740 738.902558,686.721885 738.902558,621 C738.902558,555.278115 685.624443,502 619.902558,502 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Card$2 = function Card(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(620.482323, 542.482323) rotate(45.000000) translate(-620.482323, -542.482323) translate(375.482323, 297.482323)"
  }, React.createElement("path", {
    d: "M490,140 C296.700338,140 140,296.700338 140,490",
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70"
  }), React.createElement("path", {
    d: "M490,0 C219.380473,0 0,219.380473 0,490",
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70"
  }), React.createElement("path", {
    d: "M490,280 C374.020203,280 280,374.020203 280,490",
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70"
  }), React.createElement("circle", {
    id: "Oval",
    fill: props.color,
    cx: "441",
    cy: "441",
    r: "49"
  }))));
};

var Save = function Save(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M311,332 L797.59967,332 C810.357094,332 822.58972,337.078569 831.59591,346.114079 L945.698919,460.588561 C954.658481,469.577292 959.693519,481.748513 959.702667,494.439887 L959.999992,874.979289 C960.012729,892.652396 945.696171,906.989607 928.023063,907.002344 C928.015376,907.00235 928.007688,907.002353 928,907.002353 L311,906.979297 C293.326888,906.979297 279,892.652409 279,874.979297 L279,364 C279,346.326888 293.326888,332 311,332 Z M459.977632,365.189133 C450.588791,365.189133 442.977632,372.800292 442.977632,382.189133 L442.977632,448.653534 C442.977632,458.042375 450.588791,465.653534 459.977632,465.653534 L777.230263,465.653534 C786.619104,465.653534 794.230263,458.042375 794.230263,448.653534 L794.230263,382.189133 C794.230263,372.800292 786.619104,365.189133 777.230263,365.189133 L459.977632,365.189133 Z M618.5,784 C676.766041,784 724,736.766041 724,678.5 C724,620.233959 676.766041,573 618.5,573 C560.233959,573 513,620.233959 513,678.5 C513,736.766041 560.233959,784 618.5,784 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Sync = function Sync(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(320.000000, 203.000000)"
  }, React.createElement("path", {
    d: "M1.44950718e-12,527.701524 C165.685425,527.701524 300,393.386949 300,227.701524 C300,188.603168 292.520518,151.251738 278.914319,117",
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70",
    strokeLinecap: "round",
    transform: "translate(150.000000, 322.350762) rotate(180.000000) translate(-150.000000, -322.350762) "
  }), React.createElement("path", {
    d: "M387.077709,52.1884181 L479.984734,175.270374 C483.977546,180.559997 482.926273,188.084897 477.636651,192.077709 C475.554195,193.649627 473.016153,194.5 470.407025,194.5 L284.592975,194.5 C277.965558,194.5 272.592975,189.127417 272.592975,182.5 C272.592975,179.890872 273.443348,177.35283 275.015266,175.270374 L367.922291,52.1884181 C371.915103,46.8987954 379.440003,45.8475226 384.729626,49.8403346 C385.617356,50.5104282 386.407616,51.3006873 387.077709,52.1884181 Z",
    id: "Triangle",
    fill: props.color,
    transform: "translate(377.500000, 117.000000) rotate(90.000000) translate(-377.500000, -117.000000) "
  })), React.createElement("g", {
    id: "Group",
    transform: "translate(692.500000, 773.000000) rotate(180.000000) translate(-692.500000, -773.000000) translate(465.000000, 509.000000)"
  }, React.createElement("path", {
    d: "M1.44950718e-12,527.701524 C165.685425,527.701524 300,393.386949 300,227.701524 C300,188.603168 292.520518,151.251738 278.914319,117",
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70",
    strokeLinecap: "round",
    transform: "translate(150.000000, 322.350762) rotate(180.000000) translate(-150.000000, -322.350762) "
  }), React.createElement("path", {
    d: "M387.077709,52.1884181 L479.984734,175.270374 C483.977546,180.559997 482.926273,188.084897 477.636651,192.077709 C475.554195,193.649627 473.016153,194.5 470.407025,194.5 L284.592975,194.5 C277.965558,194.5 272.592975,189.127417 272.592975,182.5 C272.592975,179.890872 273.443348,177.35283 275.015266,175.270374 L367.922291,52.1884181 C371.915103,46.8987954 379.440003,45.8475226 384.729626,49.8403346 C385.617356,50.5104282 386.407616,51.3006873 387.077709,52.1884181 Z",
    id: "Triangle",
    fill: props.color,
    transform: "translate(377.500000, 117.000000) rotate(90.000000) translate(-377.500000, -117.000000) "
  }))));
};

var Globe = function Globe(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    id: "Oval",
    stroke: props.color,
    strokeWidth: "40",
    cx: "620",
    cy: "621",
    r: "314"
  }), React.createElement("path", {
    d: "M620,935 C793.333333,935 793.333333,307 620,307 C446.666667,307 446.666667,935 620,935 Z",
    id: "Oval",
    stroke: props.color,
    strokeWidth: "40"
  }), React.createElement("path", {
    d: "M622,305 L618,935",
    id: "Path-7",
    stroke: props.color,
    strokeWidth: "40"
  }), React.createElement("path", {
    d: "M622,305 L618,936",
    id: "Path-7",
    stroke: props.color,
    strokeWidth: "40",
    transform: "translate(620.000000, 620.500000) rotate(90.000000) translate(-620.000000, -620.500000) "
  }), React.createElement("path", {
    d: "M380,812 C457.849781,770.666667 537.145131,750 617.886053,750 C698.626974,750 780.331623,770.666667 863,812",
    id: "Path-8",
    stroke: props.color,
    strokeWidth: "40"
  }), React.createElement("path", {
    d: "M376,476 C453.849781,434.666667 533.145131,414 613.886053,414 C694.626974,414 776.331623,434.666667 859,476",
    id: "Path-8",
    stroke: props.color,
    strokeWidth: "40",
    transform: "translate(617.500000, 445.000000) scale(1, -1) translate(-617.500000, -445.000000) "
  })));
};

var Card$3 = function Card(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    id: "Oval",
    stroke: props.color,
    strokeWidth: "70",
    cx: "620",
    cy: "621",
    r: "314"
  }), React.createElement("path", {
    d: "M622,305 L618,936",
    id: "Path-7",
    stroke: props.color,
    strokeWidth: "70",
    transform: "translate(620.000000, 620.500000) rotate(45.000000) translate(-620.000000, -620.500000) "
  })));
};

var Search = function Search(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(619.860263, 619.860263) rotate(-45.000000) translate(-619.860263, -619.860263) translate(390.360263, 242.860263)",
    stroke: props.color,
    strokeWidth: "70"
  }, React.createElement("circle", {
    id: "Oval",
    cx: "229.5",
    cy: "229.5",
    r: "229.5"
  }), React.createElement("path", {
    d: "M229.5,459 L229.5,754",
    id: "Path-9",
    strokeLinecap: "round"
  }))));
};

var Delete = function Delete(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M423.5,496 L423.5,935 C423.5,937.209139 425.290861,939 427.5,939 L813.5,939 C815.709139,939 817.5,937.209139 817.5,935 L817.5,496 L423.5,496 Z",
    id: "Rectangle",
    stroke: props.color,
    strokeWidth: "70"
  }), React.createElement("path", {
    d: "M511.5,391 L729.5,391 L729.5,302.567566 C729.49788,302.565676 729.495745,302.563768 729.493594,302.561849 C728.490484,301.667011 726.722683,301 724.52847,301 L516.47153,301 C514.277317,301 512.509516,301.667011 511.506406,302.561849 C511.504255,302.563768 511.50212,302.565676 511.5,302.567573 L511.5,391 Z",
    id: "Rectangle",
    stroke: props.color,
    strokeWidth: "70"
  }), React.createElement("path", {
    d: "M321.5,426 L321.5,397.657143 C321.5,377.964247 339.348915,362 361.366667,362 L879.633333,362 C901.651085,362 919.5,377.964247 919.5,397.657143 L919.5,426 L321.5,426 Z",
    id: "Rectangle",
    fill: props.color
  })));
};

var Home = function Home(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M654.128213,908.355229 L883.128213,908.355229 L883.128213,567.355229 L907.601331,567.355229 L619.628213,336.233578 L331.655095,567.355229 L353.128213,567.355229 L353.128213,908.355229 L429.128213,908.355229 L429.128213,709.355229 C429.128213,678.979568 453.752551,654.355229 484.128213,654.355229 L599.128213,654.355229 C629.503874,654.355229 654.128213,678.979568 654.128213,709.355229 L654.128213,908.355229 Z M768.628213,638.355229 C821.371406,638.355229 864.128213,681.112035 864.128213,733.855229 C864.128213,786.598423 821.371406,829.355229 768.628213,829.355229 C715.885019,829.355229 673.128213,786.598423 673.128213,733.855229 C673.128213,681.112035 715.885019,638.355229 768.628213,638.355229 Z",
    id: "Combined-Shape",
    stroke: props.color,
    strokeWidth: "70",
    fill: props.color
  })));
};

var Edit = function Edit(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(295.000000, 348.000000)",
    stroke: props.color,
    strokeWidth: "70"
  }, React.createElement("path", {
    d: "M279.347642,449.619406 L326.553571,494.283018 L370.322743,450.123263 L372.07945,13.2253757 C372.07948,13.2162008 372.07948,13.2162008 372.079481,13.2070258 C372.07823,10.9978872 370.286354,9.20804125 368.077216,9.20929304 L283.592636,9.25716536 C281.385267,9.25841615 279.596154,11.0475296 279.594903,13.2548982 L279.347642,449.619406 Z",
    id: "Rectangle",
    fill: props.color,
    transform: "translate(345.709292, 258.709292) rotate(45.000000) translate(-345.709292, -258.709292) "
  }), React.createElement("path", {
    d: "M0.5,543 L650.5,543",
    id: "Line"
  }))));
};

var Copy = function Copy(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(322.000000, 260.000000)",
    stroke: props.color,
    strokeWidth: "70"
  }, React.createElement("path", {
    d: "M561,192.300029 L421.275393,35 L124.995999,35 C122.78686,35 120.995999,36.790861 120.995999,39 L120.995999,603.00562 C120.995999,605.214759 122.78686,607.00562 124.995999,607.00562 L557,607.00562 C559.209139,607.00562 561,605.214759 561,603.00562 L561,192.300029 Z",
    id: "Rectangle"
  }), React.createElement("path", {
    d: "M561,214 L438,214 C418.117749,214 402,197.882251 402,178 L402,35 L125,35 C122.790861,35 121,36.790861 121,39 L121,603 C121,605.209139 122.790861,607 125,607 L557,607 C559.209139,607 561,605.209139 561,603 L561,214 Z",
    id: "Rectangle"
  }), React.createElement("path", {
    d: "M103,155 L40,155 C17.90861,155 1.03875995e-13,172.90861 1.0658141e-13,195 L1.13686838e-13,681.000001 C1.16392253e-13,703.091391 17.90861,721.000001 40,721.000001 L371,721.000001 C393.09139,721.000001 411,703.091391 411,681.000001 L411,624",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

var Link = function Link(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(620.099332, 620.099332) rotate(45.000000) translate(-620.099332, -620.099332) translate(472.099332, 254.599332)",
    stroke: props.color,
    strokeWidth: "60"
  }, React.createElement("path", {
    d: "M295.075444,612.224215 C295.075444,607.229646 295.082358,514.305308 295.075444,509.498916 C294.888824,379.768944 289.665107,318.452579 143.447388,318.452579 C123.590572,318.452579 106.477192,319.672222 91.7292452,322.09439 C36.0431495,331.240145 14.0812003,357.530399 5.49446999,400.043709 C-1.01078717,432.251546 0.160648953,473.77059 0.160648953,524.200177 C0.160648953,655.097197 0.160648953,730.452579 147.580437,730.452579 C169.513922,730.452579 188.185905,729.065706 204.08137,726.232489",
    id: "Oval",
    transform: "translate(147.578517, 524.452579) scale(-1, -1) translate(-147.578517, -524.452579) "
  }), React.createElement("path", {
    d: "M295.075444,294.026163 C295.075444,289.031595 295.082358,196.107257 295.075444,191.300864 C294.888824,61.5708926 289.665107,0.254527624 143.447388,0.254527624 C123.590572,0.254527624 106.477192,1.4741703 91.7292452,3.89633881 C36.0431495,13.0420936 14.0812003,39.3323478 5.49446999,81.8456576 C-1.01078717,114.053495 0.160648953,155.572538 0.160648953,206.002126 C0.160648953,336.899145 0.160648953,412.254528 147.580437,412.254528 C169.513922,412.254528 188.185905,410.867655 204.08137,408.034437",
    id: "Oval"
  }))));
};

var Clap = function Clap(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(620.422429, 619.843059) scale(-1, 1) rotate(-47.000000) translate(-620.422429, -619.843059) translate(279.922429, 311.343059)",
    fill: props.color,
    stroke: props.color,
    strokeWidth: "10"
  }, React.createElement("path", {
    d: "M391,380.678223 L391,350.678223 L580.5,350.678223 C596.240115,350.678223 609,337.918339 609,322.178223 C609,306.438108 596.240115,293.678223 580.5,293.678223 L278.658007,293.678223 L277.272865,290.926017 C273.98507,284.393334 270.662877,278.264614 267.327239,272.583934 L264.120276,267.122391 L379.773768,231.76357 C394.826115,227.161606 403.297824,211.228638 398.69586,196.176291 C394.093896,181.123944 378.160928,172.652235 363.108581,177.254199 L187.767718,230.861281 L187.625274,230.902531 C185.309974,231.53595 183.009103,232.239509 180.724141,233.012446 L180.583826,233.057617 L179.498068,233.389566 C178.308978,233.753108 177.153796,234.189234 176.036455,234.695085 L175.90759,234.753425 L175.775632,234.804387 C113.034896,259.034756 69,333.515928 69,419.178223 C69,525.7223 136.459079,611.678223 219,611.678223 L320.75,611.678223 L501.5,611.678223 C517.240115,611.678223 530,598.918339 530,583.178223 C530,567.438108 517.240115,554.678223 501.5,554.678223 L391,554.678223 L391,524.678223 L580.5,524.678223 C596.240115,524.678223 609,511.918339 609,496.178223 C609,480.438108 596.240115,467.678223 580.5,467.678223 L391,467.678225 L391,437.678223 L634.5,437.678223 C650.240115,437.678223 663,424.918339 663,409.178223 C663,393.438108 650.240115,380.678223 634.5,380.678223 L391,380.678223 Z",
    id: "Combined-Shape"
  }), React.createElement("path", {
    d: "M35.486735,441.476244 C31.2086681,423.065768 29,403.818425 29,384.178223 C29,294.678012 75.2453126,216.400741 142.04441,190.525616 C143.510313,189.868601 145.022236,189.301048 146.574351,188.826519 L147.590293,188.515914 C150.014694,187.697317 152.456538,186.950648 154.914227,186.276763 L321.350992,135.391937 C332.968403,128.917135 338.645199,115.093996 334.69586,102.176291 C330.093896,87.1239439 314.160928,78.6522348 299.108581,83.2541991 L123.767718,136.861281 L123.625274,136.902531 C121.309974,137.53595 119.009103,138.239509 116.724141,139.012446 L116.583826,139.057617 L115.498068,139.389566 C114.308978,139.753108 113.153796,140.189234 112.036455,140.695085 L111.90759,140.753425 L111.775632,140.804387 C49.0348963,165.034756 5,239.515928 5,325.178223 C5,367.981268 15.9544825,408.505065 35.4867294,441.476235 Z M447,199.678223 L447,256.678223 L516.5,256.678223 C532.240115,256.678223 545,243.918339 545,228.178223 C545,212.438108 532.240115,199.678223 516.5,199.678223 L447,199.678223 Z",
    id: "Combined-Shape"
  }), React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(581.853188, 89.494808) scale(1, -1) rotate(-43.000000) translate(-581.853188, -89.494808) ",
    points: "581.853188 47.4948079 610.853188 131.494808 552.853188 131.494808"
  }), React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(509.299296, 47.768155) scale(1, -1) rotate(-14.000000) translate(-509.299296, -47.768155) ",
    points: "509.299296 5.76815548 538.299296 89.7681555 480.299296 89.7681555"
  }), React.createElement("path", {
    d: "M391,380.678223 L391,350.678223 L580.5,350.678223 C596.240115,350.678223 609,337.918339 609,322.178223 C609,306.438108 596.240115,293.678223 580.5,293.678223 L278.658007,293.678223 L277.272865,290.926017 C273.98507,284.393334 270.662877,278.264614 267.327239,272.583934 L264.120276,267.122391 L379.773768,231.76357 C394.826115,227.161606 403.297824,211.228638 398.69586,196.176291 C394.093896,181.123944 378.160928,172.652235 363.108581,177.254199 L187.767718,230.861281 L187.625274,230.902531 C185.309974,231.53595 183.009103,232.239509 180.724141,233.012446 L180.583826,233.057617 L179.498068,233.389566 C178.308978,233.753108 177.153796,234.189234 176.036455,234.695085 L175.90759,234.753425 L175.775632,234.804387 C113.034896,259.034756 69,333.515928 69,419.178223 C69,525.7223 136.459079,611.678223 219,611.678223 L298,611.678223 L320.75,611.678223 L501.5,611.678223 C517.240115,611.678223 530,598.918339 530,583.178223 C530,567.438108 517.240115,554.678223 501.5,554.678223 L391,554.678223 L391,524.678223 L580.5,524.678223 C596.240115,524.678223 609,511.918339 609,496.178223 C609,480.438108 596.240115,467.678223 580.5,467.678223 L391,467.678225 L391,437.678223 L634.5,437.678223 C650.240115,437.678223 663,424.918339 663,409.178223 C663,393.438108 650.240115,380.678223 634.5,380.678223 L391,380.678223 Z",
    id: "Combined-Shape"
  }), React.createElement("path", {
    d: "M35.486735,441.476244 C31.2086681,423.065768 29,403.818425 29,384.178223 C29,294.678012 75.2453126,216.400741 142.04441,190.525616 C143.510313,189.868601 145.022236,189.301048 146.574351,188.826519 L147.590293,188.515914 C150.014694,187.697317 152.456538,186.950648 154.914227,186.276763 L321.350992,135.391937 C332.968403,128.917135 338.645199,115.093996 334.69586,102.176291 C330.093896,87.1239439 314.160928,78.6522348 299.108581,83.2541991 L123.767718,136.861281 L123.625274,136.902531 C121.309974,137.53595 119.009103,138.239509 116.724141,139.012446 L116.583826,139.057617 L115.498068,139.389566 C114.308978,139.753108 113.153796,140.189234 112.036455,140.695085 L111.90759,140.753425 L111.775632,140.804387 C49.0348963,165.034756 5,239.515928 5,325.178223 C5,367.981268 15.9544825,408.505065 35.4867294,441.476235 Z M446.546944,199.678223 C444.882323,213.666076 440.143761,227.626911 432.363914,241.537986 C429.30658,247.004779 425.681624,252.053108 421.494159,256.678223 L516.5,256.678223 C532.240115,256.678223 545,243.918339 545,228.178223 C545,212.438108 532.240115,199.678223 516.5,199.678223 L446.546944,199.678223 Z",
    id: "Combined-Shape"
  }), React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(581.853188, 89.494808) scale(1, -1) rotate(-43.000000) translate(-581.853188, -89.494808) ",
    points: "581.853188 47.4948079 610.853188 131.494808 552.853188 131.494808"
  }), React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(509.299296, 47.768155) scale(1, -1) rotate(-14.000000) translate(-509.299296, -47.768155) ",
    points: "509.299296 5.76815548 538.299296 89.7681555 480.299296 89.7681555"
  }), React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(631.905867, 166.559353) scale(1, -1) rotate(-72.000000) translate(-631.905867, -166.559353) ",
    points: "631.905867 124.559353 660.905867 208.559353 602.905867 208.559353"
  }), React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(631.905867, 166.559353) scale(1, -1) rotate(-72.000000) translate(-631.905867, -166.559353) ",
    points: "631.905867 124.559353 660.905867 208.559353 602.905867 208.559353"
  }))));
};

var Card$4 = function Card(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M591.00778,573.743164 L591.00778,598.514399 L894.50778,598.514399 C913.009319,598.514399 928.00778,613.512859 928.00778,632.014399 L928.00778,647.998036 C928.00778,666.499575 913.009319,681.498036 894.50778,681.498036 L591.00778,681.498036 L591.00778,706.269273 L827.633608,706.269271 C846.135147,706.269271 861.133608,721.267732 861.133608,739.769271 L861.133608,755.752908 C861.133608,774.254447 846.135147,789.252908 827.633608,789.252908 L591.00778,789.252908 L591.00778,814.024143 L729.799171,814.024143 C748.30071,814.024143 763.299171,829.022604 763.299171,847.524143 L763.299171,863.50778 C763.299171,882.009319 748.30071,897.00778 729.799171,897.00778 L396.792548,897.00778 C393.979171,897.00778 391.246795,896.660974 388.635838,896.00778 L479.714664,896.00778 C476.589871,896.668491 473.285466,897.00778 469.79586,897.00778 C442.019338,897.00778 411.303357,897.00778 371.961423,897.00778 C265.948353,897.00778 180.00778,787.489491 180.00778,652.391835 C180.00778,530.081463 250.449376,428.73734 342.453671,410.648243 L342.453683,410.648239 L556.159387,344.499154 C573.833598,339.028393 592.596305,348.921243 598.067066,366.595454 C598.090131,366.669968 598.112935,366.744563 598.135479,366.819237 L602.517093,381.33292 C607.83787,398.957492 597.939355,417.573057 580.35238,423.016816 L436.977274,467.396222 C441.266079,474.684488 445.50156,482.499459 449.658212,490.759526 L827.633608,490.759526 C846.135147,490.759526 861.133608,505.757987 861.133608,524.259526 L861.133608,540.243164 C861.133608,558.744703 846.135147,573.743164 827.633608,573.743164 L591.00778,573.743164 Z",
    id: "Combined-Shape",
    fill: props.color,
    transform: "translate(554.007780, 620.000000) rotate(-90.000000) translate(-554.007780, -620.000000) "
  })));
};

var Card$5 = function Card(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M559,926.947847 L559,926.997703 L324,926.997703 L324,619.997703 L420.128306,619.997703 C436.54537,573.703124 465.255961,536.030106 500.943381,513.76593 C520.313809,496.671842 532.784309,478.637343 538.354881,459.662434 C546.364373,432.379883 544.147318,401.512807 531.703713,367.061207 L531.703732,367.0612 C524.141279,346.123647 534.983939,323.019828 555.921492,315.457374 C559.443964,314.185089 563.126566,313.409935 566.863029,313.154281 C600.481289,310.854068 630.326228,334.519331 635.749241,367.776951 C642.052965,406.435865 645.853597,434.43093 647.15111,451.76215 C648.298988,467.094652 648.737568,490.77456 648.466848,522.801876 L847.656327,522.801876 C876.558911,522.801876 899.989084,546.232049 899.989084,575.134633 C899.989084,596.643352 887.01337,615.121431 868.462865,623.167947 C894.638165,626.051761 915,648.239709 915,675.183418 C915,702.068019 894.727404,724.217702 868.635046,727.179631 C887.209271,735.215892 900.205719,753.706305 900.205719,775.232202 C900.205719,802.419284 879.474379,824.764303 852.957874,827.321083 C871.418447,835.406163 884.315669,853.837421 884.315669,875.280987 C884.315669,904.183571 860.885496,927.613744 831.982912,927.613744 L668.846388,927.613744 C666.954042,927.86823 664.992539,927.997703 662.960487,927.997703 C638.234677,927.997703 610.89225,927.997703 575.871263,927.997703 C570.178189,927.997703 564.550144,927.642273 559,926.947847 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var Card$6 = function Card(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M559,926.947847 L559,926.997703 L324,926.997703 L324,619.997703 L420.128306,619.997703 C436.54537,573.703124 465.255961,536.030106 500.943381,513.76593 C520.313809,496.671842 532.784309,478.637343 538.354881,459.662434 C546.364373,432.379883 544.147318,401.512807 531.703713,367.061207 L531.703732,367.0612 C524.141279,346.123647 534.983939,323.019828 555.921492,315.457374 C559.443964,314.185089 563.126566,313.409935 566.863029,313.154281 C600.481289,310.854068 630.326228,334.519331 635.749241,367.776951 C642.052965,406.435865 645.853597,434.43093 647.15111,451.76215 C648.298988,467.094652 648.737568,490.77456 648.466848,522.801876 L847.656327,522.801876 C876.558911,522.801876 899.989084,546.232049 899.989084,575.134633 C899.989084,596.643352 887.01337,615.121431 868.462865,623.167947 C894.638165,626.051761 915,648.239709 915,675.183418 C915,702.068019 894.727404,724.217702 868.635046,727.179631 C887.209271,735.215892 900.205719,753.706305 900.205719,775.232202 C900.205719,802.419284 879.474379,824.764303 852.957874,827.321083 C871.418447,835.406163 884.315669,853.837421 884.315669,875.280987 C884.315669,904.183571 860.885496,927.613744 831.982912,927.613744 L668.846388,927.613744 C666.954042,927.86823 664.992539,927.997703 662.960487,927.997703 C638.234677,927.997703 610.89225,927.997703 575.871263,927.997703 C570.178189,927.997703 564.550144,927.642273 559,926.947847 Z",
    id: "Combined-Shape",
    fill: props.color,
    transform: "translate(619.500000, 620.498851) scale(1, -1) translate(-619.500000, -620.498851) "
  })));
};

var RockOn = function RockOn(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M640.80009,589.550236 L640.80009,614.358654 L654.272817,614.358654 C672.774356,614.358654 687.772817,629.357114 687.772817,647.858654 L687.772817,663.966854 C687.772817,682.468393 672.774356,697.466854 654.272817,697.466854 L640.80009,697.466854 L640.80009,722.275272 L650.547363,722.275272 C669.048902,722.275272 684.047363,737.273733 684.047363,755.775272 L684.047363,771.883472 C684.047363,790.385011 669.048902,805.383472 650.547363,805.383472 L640.80009,805.383472 L640.80009,830.19189 L779.696454,830.19189 C798.197993,830.19189 813.196454,845.190351 813.196454,863.69189 L813.196454,879.80009 C813.196454,898.301629 798.197993,913.30009 779.696454,913.30009 L445.589181,913.30009 C443.611661,913.30009 441.674161,913.128745 439.790717,912.80009 L526.008703,912.80009 C523.72524,913.131336 521.351507,913.30009 518.885545,913.30009 C491.032593,913.30009 460.232096,913.30009 420.781908,913.30009 C314.477135,913.30009 228.30009,803.617408 228.30009,668.316963 C228.30009,549.608418 294.637286,450.619864 382.703283,428.127076 C383.462004,427.83399 384.232671,427.568048 385.013914,427.330094 C419.720518,416.759037 454.427123,406.187979 489.133728,395.616922 C518.793401,386.583076 544.754538,392.345778 569.30009,421.626265 C577.325498,431.199806 591.841737,459.471729 612.848806,506.442035 L877.80009,506.442035 C896.301629,506.442035 911.30009,521.440496 911.30009,539.942035 L911.30009,556.050236 C911.30009,574.551775 896.301629,589.550236 877.80009,589.550236 L640.80009,589.550236 Z M489.96847,489.996621 C492.908453,495.248754 495.81925,500.739483 498.692487,506.442035 L518.155904,506.442035 C506.953366,494.859173 497.557557,489.377371 489.96847,489.996621 Z",
    id: "Combined-Shape",
    fill: props.color,
    transform: "translate(569.800090, 652.500000) rotate(-90.000000) translate(-569.800090, -652.500000) "
  })));
};

var Heart = function Heart(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M295.079363,544.737482 C291.757896,530.699187 290,516.055162 290,501 C290,500.973294 290.000006,500.946588 290.000017,500.919884 C290.000006,500.894213 290,500.868546 290,500.84288 C290,499.70885 290.010799,498.582082 290.032397,497.462574 C291.915846,394.713103 375.683091,312 478.742718,312 C534.682103,312 584.937617,336.36871 619.5,375.083223 C654.062383,336.36871 704.317897,312 760.257282,312 C863.893976,312 948.021634,395.641976 948.991528,499.19044 C948.997176,499.766554 949,500.34455 949,500.924444 C948.999995,500.949628 949,500.974814 949,501 C949,515.486484 947.372398,529.592302 944.290319,543.144093 C921.167837,649.730591 812.904398,778.015892 619.5,928 C427.106857,778.752489 318.966646,650.998322 295.079367,544.737498 Z",
    id: "Combined-Shape",
    fill: props.color
  })));
};

var HeartOutlined = function HeartOutlined(props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 1240 1240",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M295.079363,544.737482 C291.757896,530.699187 290,516.055162 290,501 C290,500.973294 290.000006,500.946588 290.000017,500.919884 C290.000006,500.894213 290,500.868546 290,500.84288 C290,499.70885 290.010799,498.582082 290.032397,497.462574 C291.915846,394.713103 375.683091,312 478.742718,312 C534.682103,312 584.937617,336.36871 619.5,375.083223 C654.062383,336.36871 704.317897,312 760.257282,312 C863.893976,312 948.021634,395.641976 948.991528,499.19044 C948.997176,499.766554 949,500.34455 949,500.924444 C948.999995,500.949628 949,500.974814 949,501 C949,515.486484 947.372398,529.592302 944.290319,543.144093 C921.167837,649.730591 812.904398,778.015892 619.5,928 C427.106857,778.752489 318.966646,650.998322 295.079367,544.737498 Z",
    id: "Combined-Shape",
    stroke: props.color,
    strokeWidth: "70"
  })));
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var Icon = function (_Component) {
  inherits(Icon, _Component);

  function Icon() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Icon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Icon.__proto__ || Object.getPrototypeOf(Icon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      iconId: 'icon_' + uid_1(10),
      size: null,
      color: null,
      opacity: null
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Icon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          size = _props.size,
          color = _props.color; // Get the style from the parent component (color + fontSize)

      if (!size || !color) {
        var parent = document.getElementById(this.state.iconId).parentNode;
        var parentStyle = getComputedStyle(parent); // Get the font size if there is no size specified

        var iconSize = size; // Scale the icon so it look bigger if it get it's size from it's parent fontSize

        if (!size) {
          var pxSize = parentStyle["font-size"].split("px")[0] * 1.3;
          iconSize = pxSize + 'px';
        } // Get the color if there is no color specified


        var iconColor = color ? color : parentStyle["color"];
        var iconOpacity = 1; // convert it to a rgba color if it's an hex color

        if (iconColor.split("#").length > 1) {
          iconColor = 'rgba(' + hexRgb(iconColor, {
            format: 'array'
          }).join(", ") + ')';
        } // If it's a RGBA color
        // get the rgb color and the opacity separately if there is opacity


        if (iconColor.split("rgba").length > 1) {
          // get the opacity first
          iconOpacity = Number(iconColor.split(",")[3].split(")")[0]); // get the rgb color

          var iconColorNum = iconColor.split("rgba(")[1].split(",").slice(0, 3).join(",");
          iconColor = 'rgb(' + iconColorNum + ')';
        }

        this.setState({
          size: iconSize,
          color: iconColor,
          opacity: iconOpacity
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // Choose the right icon
      var chosenIcon = void 0;

      switch (this.props.type) {
        case "close":
          chosenIcon = React.createElement(CloseIcon, null);
          break;

        case "arrowBack":
          chosenIcon = React.createElement(ArrowBack, null);
          break;

        case "arrowTop":
          chosenIcon = React.createElement(ArrowTop, null);
          break;

        case "arrowForward":
          chosenIcon = React.createElement(ArrowForward, null);
          break;

        case "arrowDown":
          chosenIcon = React.createElement(ArrowDown, null);
          break;

        case "checkmark":
          chosenIcon = React.createElement(CheckMark, null);
          break;

        case "menu":
          chosenIcon = React.createElement(Menu, null);
          break;

        case "cycling":
          chosenIcon = React.createElement(Cycling, null);
          break;

        case "chart":
          chosenIcon = React.createElement(LineChart, null);
          break;

        case "star":
          chosenIcon = React.createElement(Star, null);
          break;

        case "starOutlined":
          chosenIcon = React.createElement(StarOutlined, null);
          break;

        case "starHalf":
          chosenIcon = React.createElement(Star$1, null);
          break;

        case "bookmark":
          chosenIcon = React.createElement(Bookmark, null);
          break;

        case "bookmarkOutlined":
          chosenIcon = React.createElement(BookmarkOutlined, null);
          break;

        case "cloudUpload":
          chosenIcon = React.createElement(CloudUpload, null);
          break;

        case "cloudDownload":
          chosenIcon = React.createElement(CloudDownload, null);
          break;

        case "cloud":
          chosenIcon = React.createElement(Cloud, null);
          break;

        case "cloudOutlined":
          chosenIcon = React.createElement(Cloud$1, null);
          break;

        case "coffee":
          chosenIcon = React.createElement(Coffee, null);
          break;

        case "lock":
          chosenIcon = React.createElement(Lock, null);
          break;

        case "unlock":
          chosenIcon = React.createElement(UnLock, null);
          break;

        case "time":
          chosenIcon = React.createElement(Time, null);
          break;

        case "flash":
          chosenIcon = React.createElement(Flash, null);
          break;

        case "loader":
          chosenIcon = React.createElement(Loader, null);
          break;

        case "plus":
          chosenIcon = React.createElement(Time$1, null);
          break;

        case "minus":
          chosenIcon = React.createElement(Time$2, null);
          break;

        case "cash":
          chosenIcon = React.createElement(Time$3, null);
          break;

        case "card":
          chosenIcon = React.createElement(Card, null);
          break;

        case "cart":
          chosenIcon = React.createElement(Cart, null);
          break;

        case "chat":
          chosenIcon = React.createElement(Card$1, null);
          break;

        case "code":
          chosenIcon = React.createElement(Code, null);
          break;

        case "bell":
          chosenIcon = React.createElement(Bell, null);
          break;

        case "bellOutlined":
          chosenIcon = React.createElement(Bell$1, null);
          break;

        case "user":
          chosenIcon = React.createElement(Cart$1, null);
          break;

        case "refresh":
          chosenIcon = React.createElement(Refresh, null);
          break;

        case "settings":
          chosenIcon = React.createElement(Settings, null);
          break;

        case "wifi":
          chosenIcon = React.createElement(Card$2, null);
          break;

        case "save":
          chosenIcon = React.createElement(Save, null);
          break;

        case "sync":
          chosenIcon = React.createElement(Sync, null);
          break;

        case "globe":
          chosenIcon = React.createElement(Globe, null);
          break;

        case "stop":
          chosenIcon = React.createElement(Card$3, null);
          break;

        case "search":
          chosenIcon = React.createElement(Search, null);
          break;

        case "delete":
          chosenIcon = React.createElement(Delete, null);
          break;

        case "edit":
          chosenIcon = React.createElement(Edit, null);
          break;

        case "copy":
          chosenIcon = React.createElement(Copy, null);
          break;

        case "home":
          chosenIcon = React.createElement(Home, null);
          break;

        case "link":
          chosenIcon = React.createElement(Link, null);
          break;

        case "clap":
          chosenIcon = React.createElement(Clap, null);
          break;

        case "hand":
          chosenIcon = React.createElement(Card$4, null);
          break;

        case "thumbUp":
          chosenIcon = React.createElement(Card$5, null);
          break;

        case "thumbDown":
          chosenIcon = React.createElement(Card$6, null);
          break;

        case "rockOn":
          chosenIcon = React.createElement(RockOn, null);
          break;

        case "heart":
          chosenIcon = React.createElement(Heart, null);
          break;

        case "heartOutlined":
          chosenIcon = React.createElement(HeartOutlined, null);
          break;

        default:
          console.error(this.props.type + ' is not a valid icon.');
      } // Add the props to the element if the icon exist


      var elementWithProps = null;

      if (chosenIcon) {
        elementWithProps = React.cloneElement(chosenIcon, {
          size: this.state.size,
          color: this.state.color,
          isSpinning: this.props.isSpinning
        });
      } // Check if the icon should be spinning


      var isSpinning = ""; // Put the default spin to the loader icon!

      if (this.props.type === "loader") {
        if (this.props.isSpinning !== false) {
          isSpinning = styles$1.isSpinning;
        }
      } // Otherwise, check if it have the isSpinning props
      else if (this.props.isSpinning === true) {
          isSpinning = styles$1.isSpinning;
        }

      return React.createElement('span', {
        id: this.state.iconId,
        className: styles$1.iconSvg + ' ' + isSpinning,
        style: {
          opacity: this.state.opacity
        }
      }, elementWithProps);
    }
  }]);
  return Icon;
}(Component);

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string // isSpinning: PropTypes.boolean,

};
var colrConvert = {
  grayscale: {
    rgb: grayscale2rgb
  },
  hex: {
    rgb: hex2rgb
  },
  rgb: {
    hsl: rgb2hsl,
    hsv: rgb2hsv,
    hex: rgb2hex,
    grayscale: rgb2grayscale
  },
  hsl: {
    rgb: hsl2rgb,
    hsv: hsl2hsv
  },
  hsv: {
    rgb: hsv2rgb,
    hsl: hsv2hsl
  }
}; // convert a charcode to a hex val

function hexVal(c) {
  return c < 58 ? c - 48 : // 0 - 9
  c < 71 ? c - 55 : // A - F
  c - 87 // a - f
  ;
}

function hex2rgb(hex) {
  var i = hex[0] === '#' ? 1 : 0;
  var len = hex.length;

  if (len - i < 3) {
    throw new Error('hex input must be at least three chars long');
  }

  var r, g, b;
  var h1 = hexVal(hex.charCodeAt(0 + i));
  var h2 = hexVal(hex.charCodeAt(1 + i));
  var h3 = hexVal(hex.charCodeAt(2 + i));

  if (len - i >= 6) {
    r = (h1 << 4) + h2;
    g = (h3 << 4) + hexVal(hex.charCodeAt(3 + i));
    b = (hexVal(hex.charCodeAt(4 + i)) << 4) + hexVal(hex.charCodeAt(5 + i));
  } else {
    r = (h1 << 4) + h1;
    g = (h2 << 4) + h2;
    b = (h3 << 4) + h3;
  }

  if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
    throw new Error('hex input is invalid');
  }

  return [r, g, b];
}

function rgb2hex(rgb) {
  return '#' + ('000000' + ((rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16)).slice(-6);
}

function rgb2hsl(rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var min = Math.min(r, g, b);
  var max = Math.max(r, g, b);
  var delta = max - min;
  var h, s, l;

  if (max === min) {
    h = 0;
  } else if (r === max) {
    h = (g - b) / delta;
  } else if (g === max) {
    h = 2 + (b - r) / delta;
  } else if (b === max) {
    h = 4 + (r - g) / delta;
  }

  h = Math.min(h * 60, 360);

  if (h < 0) {
    h += 360;
  }

  l = (min + max) / 2;

  if (max === min) {
    s = 0;
  } else if (l <= 0.5) {
    s = delta / (max + min);
  } else {
    s = delta / (2 - max - min);
  }

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0];
  var g = rgb[1];
  var b = rgb[2];
  var min = Math.min(r, g, b);
  var max = Math.max(r, g, b);
  var delta = max - min;
  var h, s, v;

  if (max === 0) {
    s = 0;
  } else {
    s = delta / max * 100;
  }

  if (max === min) {
    h = 0;
  } else if (r === max) {
    h = (g - b) / delta;
  } else if (g === max) {
    h = 2 + (b - r) / delta;
  } else if (b === max) {
    h = 4 + (r - g) / delta;
  }

  h = Math.min(h * 60, 360);

  if (h < 0) {
    h += 360;
  }

  v = max / 255 * 100;
  return [h, s, v];
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360;
  var s = hsl[1] / 100;
  var l = hsl[2] / 100;
  var r, g, b;

  if (s === 0) {
    // monochrome
    r = g = b = l;
  } else {
    var q = l < 0.5 ? l * (s + 1) : l + s - l * s;
    var p = 2 * l - q;
    var t; // red

    t = h + 1 / 3;

    if (t < 0) {
      t += 1;
    } else if (t > 1) {
      t -= 1;
    }

    if (t < 1 / 6) {
      r = p + (q - p) * t * 6;
    } else if (t < 1 / 2) {
      r = q;
    } else if (t < 2 / 3) {
      r = p + (q - p) * (2 / 3 - t) * 6;
    } else {
      r = p;
    } // green


    t = h;

    if (t < 0) {
      t += 1;
    } else if (t > 1) {
      t -= 1;
    }

    if (t < 1 / 6) {
      g = p + (q - p) * t * 6;
    } else if (t < 1 / 2) {
      g = q;
    } else if (t < 2 / 3) {
      g = p + (q - p) * (2 / 3 - t) * 6;
    } else {
      g = p;
    } // blue


    t = h - 1 / 3;

    if (t < 0) {
      t += 1;
    } else if (t > 1) {
      t -= 1;
    }

    if (t < 1 / 6) {
      b = p + (q - p) * t * 6;
    } else if (t < 1 / 2) {
      b = q;
    } else if (t < 2 / 3) {
      b = p + (q - p) * (2 / 3 - t) * 6;
    } else {
      b = p;
    }
  }

  return [r * 255, g * 255, b * 255];
}

function hsl2hsv(hsl) {
  var h = hsl[0];
  var s = hsl[1] / 100;
  var l = hsl[2] / 100;
  var sv, v;

  if (s === 0) {
    return [h, 0, l * 100];
  }

  if (l === 0) {
    return [h, 0, 0];
  }

  l *= 2;
  s *= l <= 1 ? l : 2 - l;
  v = (l + s) / 2;
  sv = 2 * s / (l + s);
  return [h, sv * 100, v * 100];
}

function hsv2rgb(hsv) {
  var h = hsv[0] / 60;
  var s = hsv[1] / 100;
  var v = hsv[2] / 100;
  var hi = Math.floor(h) % 6;
  var f = h - Math.floor(h);
  var p = 255 * v * (1 - s);
  var q = 255 * v * (1 - s * f);
  var t = 255 * v * (1 - s * (1 - f));
  v = 255 * v;

  switch (hi) {
    case 0:
      return [v, t, p];

    case 1:
      return [q, v, p];

    case 2:
      return [p, v, t];

    case 3:
      return [p, q, v];

    case 4:
      return [t, p, v];

    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0];
  var s = hsv[1] / 100;
  var v = hsv[2] / 100;
  var sl, l;

  if (s === 0) {
    return [h, 0, v * 100];
  }

  if (v === 0) {
    return [h, 0, 0];
  }

  l = (2 - s) * v;
  sl = s * v;
  sl /= l <= 1 ? l : 2 - l;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function grayscale2rgb(value) {
  return [value, value, value];
}

function rgb2grayscale(rgb) {
  return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
}
/*
 * DEPENDENCIES
 */

/*
 * CONSTRUCTOR
 */


function Colr() {
  if (this instanceof Colr === false) {
    return new Colr();
  }

  this._ = {};
}
/*
 * STATIC METHODS
 */


Colr.fromHex = function (hex) {
  return new Colr().fromHex(hex);
};

Colr.fromGrayscale = function (value) {
  return new Colr().fromGrayscale(value);
};

Colr.fromRgb = function (r, g, b) {
  return new Colr().fromRgb(r, g, b);
};

Colr.fromRgbArray = function (arr) {
  return new Colr().fromRgb(arr[0], arr[1], arr[2]);
};

Colr.fromRgbObject = function (obj) {
  return new Colr().fromRgb(obj.r, obj.g, obj.b);
};

Colr.fromHsl = function (h, s, l) {
  return new Colr().fromHsl(h, s, l);
};

Colr.fromHslArray = function (arr) {
  return new Colr().fromHsl(arr[0], arr[1], arr[2]);
};

Colr.fromHslObject = function (obj) {
  return new Colr().fromHsl(obj.h, obj.s, obj.l);
};

Colr.fromHsv = function (h, s, v) {
  return new Colr().fromHsv(h, s, v);
};

Colr.fromHsvArray = function (arr) {
  return new Colr().fromHsv(arr[0], arr[1], arr[2]);
};

Colr.fromHsvObject = function (obj) {
  return new Colr().fromHsv(obj.h, obj.s, obj.v);
};
/*
 * IMPORTERS
 */
// HEX


Colr.prototype.fromHex = function (input) {
  var value = colrConvert.hex.rgb(input);
  this._ = {
    rgb: value
  };
  return this;
}; // GRAYSCALE


Colr.prototype.fromGrayscale = function (input) {
  input = clampByte(input);
  var value = colrConvert.grayscale.rgb(input);
  this._ = {
    rgb: value
  };
  return this;
}; // RGB


Colr.prototype.fromRgb = function (r, g, b) {
  if (typeof r !== 'number' || typeof g !== 'number' || typeof b !== 'number') {
    throw new Error('Arguments must be numbers');
  }

  var value = clampRgb(r, g, b);
  this._ = {
    rgb: value
  };
  return this;
};

Colr.prototype.fromRgbArray = function (arr) {
  return this.fromRgb(arr[0], arr[1], arr[2]);
};

Colr.prototype.fromRgbObject = function (obj) {
  return this.fromRgb(obj.r, obj.g, obj.b);
}; // HSL


Colr.prototype.fromHsl = function (h, s, l) {
  if (typeof h !== 'number' || typeof s !== 'number' || typeof l !== 'number') {
    throw new Error('Arguments must be numbers');
  }

  this._ = {
    hsl: clampHsx(h, s, l)
  };
  return this;
};

Colr.prototype.fromHslArray = function (arr) {
  return this.fromHsl(arr[0], arr[1], arr[2]);
};

Colr.prototype.fromHslObject = function (obj) {
  return this.fromHsl(obj.h, obj.s, obj.l);
}; // HSV


Colr.prototype.fromHsv = function (h, s, v) {
  if (typeof h !== 'number' || typeof s !== 'number' || typeof v !== 'number') {
    throw new Error('Arguments must be numbers');
  }

  this._ = {
    hsv: clampHsx(h, s, v)
  };
  return this;
};

Colr.prototype.fromHsvArray = function (arr) {
  return this.fromHsv(arr[0], arr[1], arr[2]);
};

Colr.prototype.fromHsvObject = function (obj) {
  return this.fromHsv(obj.h, obj.s, obj.v);
};
/*
 * EXPORTERS
 */
// HEX


Colr.prototype.toHex = function () {
  var cached = this._.hex;

  if (cached !== undefined) {
    return cached;
  }

  var input;
  var cachedFrom = this._.rgb;

  if (cachedFrom !== undefined) {
    input = cachedFrom;
  } else {
    input = this.toRawRgbArray();
  }

  input[0] = Math.round(input[0]);
  input[1] = Math.round(input[1]);
  input[2] = Math.round(input[2]);
  var value = colrConvert.rgb.hex(input);
  this._.hex = value;
  return value;
}; // GRAYSCALE


Colr.prototype.toGrayscale = function () {
  var cached = this._.grayscale;

  if (cached !== undefined) {
    return cached;
  }

  var input;
  var cachedFrom = this._.rgb;

  if (cachedFrom !== undefined) {
    input = cachedFrom;
  } else {
    input = this.toRawRgbArray();
  }

  var value = colrConvert.rgb.grayscale(input);
  this._.grayscale = value;
  return value;
}; // RGB


Colr.prototype.toRawRgbArray = function () {
  var cached = this._.rgb;

  if (cached !== undefined) {
    return cached;
  }

  var value;

  if ((value = this._.hsv) !== undefined) {
    value = colrConvert.hsv.rgb(value);
  } else if ((value = this._.hsl) !== undefined) {
    value = colrConvert.hsl.rgb(value);
  } else {
    throw new Error('No data to convert');
  }

  this._.rgb = value;
  return value;
};

Colr.prototype.toRawRgbObject = function () {
  var arr = this.toRawRgbArray();
  return {
    r: arr[0],
    g: arr[1],
    b: arr[2]
  };
};

Colr.prototype.toRgbArray = function () {
  var arr = this.toRawRgbArray();
  return [Math.round(arr[0]), Math.round(arr[1]), Math.round(arr[2])];
};

Colr.prototype.toRgbObject = function () {
  var arr = this.toRgbArray();
  return {
    r: arr[0],
    g: arr[1],
    b: arr[2]
  };
}; // HSL


Colr.prototype.toRawHslArray = function () {
  var cached = this._.hsl;

  if (cached !== undefined) {
    return cached;
  }

  var value;

  if ((value = this._.hsv) !== undefined) {
    value = colrConvert.hsv.hsl(value);
  } else if ((value = this._.rgb) !== undefined) {
    value = colrConvert.rgb.hsl(value);
  } else {
    throw new Error('No data to convert');
  }

  this._.hsl = value;
  return value;
};

Colr.prototype.toRawHslObject = function () {
  var arr = this.toRawHslArray();
  return {
    h: arr[0],
    s: arr[1],
    l: arr[2]
  };
};

Colr.prototype.toHslArray = function () {
  var arr = this.toRawHslArray();
  return [Math.round(arr[0]), Math.round(arr[1]), Math.round(arr[2])];
};

Colr.prototype.toHslObject = function () {
  var arr = this.toHslArray();
  return {
    h: arr[0],
    s: arr[1],
    l: arr[2]
  };
}; // HSV


Colr.prototype.toRawHsvArray = function () {
  var cached = this._.hsv;

  if (cached !== undefined) {
    return cached;
  }

  var value;

  if ((value = this._.hsl) !== undefined) {
    value = colrConvert.hsl.hsv(value);
  } else if ((value = this._.rgb) !== undefined) {
    value = colrConvert.rgb.hsv(value);
  } else {
    throw new Error('No data to convert');
  }

  this._.hsv = value;
  return value;
};

Colr.prototype.toRawHsvObject = function () {
  var arr = this.toRawHsvArray();
  return {
    h: arr[0],
    s: arr[1],
    v: arr[2]
  };
};

Colr.prototype.toHsvArray = function () {
  var arr = this.toRawHsvArray();
  return [Math.round(arr[0]), Math.round(arr[1]), Math.round(arr[2])];
};

Colr.prototype.toHsvObject = function () {
  var arr = this.toHsvArray();
  return {
    h: arr[0],
    s: arr[1],
    v: arr[2]
  };
};
/*
 * MODIFIERS
 */


Colr.prototype.lighten = function (amount) {
  var hsl = this.toRawHslArray();
  hsl[2] = clampPercentage(hsl[2] + amount);
  this._ = {
    hsl: hsl
  };
  return this;
};

Colr.prototype.darken = function (amount) {
  var hsl = this.toRawHslArray();
  hsl[2] = clampPercentage(hsl[2] - amount);
  this._ = {
    hsl: hsl
  };
  return this;
};
/*
 * MISC
 */


Colr.prototype.clone = function () {
  var colr = new Colr();
  colr._.hex = this._.hex;
  colr._.grayscale = this._.grayscale;

  if (this._.rgb !== undefined) {
    colr._.rgb = this._.rgb.slice(0);
  }

  if (this._.hsv !== undefined) {
    colr._.hsv = this._.hsv.slice(0);
  }

  if (this._.hsl !== undefined) {
    colr._.hsl = this._.hsl.slice(0);
  }

  return colr;
};
/*
 * UTILS
 */


function clampPercentage(val) {
  return Math.max(Math.min(val, 100), 0);
}

function clampByte(byte) {
  return Math.max(Math.min(byte, 255), 0);
}

function clampRgb(r, g, b) {
  return [Math.max(Math.min(r, 255), 0), Math.max(Math.min(g, 255), 0), Math.max(Math.min(b, 255), 0)];
}

function clampHsx(h, s, x) {
  return [Math.max(Math.min(h, 360), 0), Math.max(Math.min(s, 100), 0), Math.max(Math.min(x, 100), 0)];
}

var colr = Colr; // This is the default colors

var defaultColor = "#0019d8";
var defaultTextColor = "#ffffff";
var primaryColor = "#006eff";
var primaryTextColor = "#ffffff";
var successColor = "#23d160";
var successTextColor = "#ffffff";
var dangerColor = "#ff2a2a";
var dangerTextColor = "#ffffff";

var _templateObject = taggedTemplateLiteral(["\n\t\t\tbackground-color: none;\n\t\t\tcolor: ", ";\n\n\t\t\t:hover {\n\t\t    background-color: ", "15;\n\t\t  }\n\n\t\t\t:focus {\n\t\t\t\tbackground-color: none;\n\t\t\t\tbox-shadow: 0 0 0 2.5px ", "66;\n\t\t\t}\n\n\t\t\t:active {\n\t\t\t\tbackground-color: ", "33;\n\t\t\t}\n\t\t"], ["\n\t\t\tbackground-color: none;\n\t\t\tcolor: ", ";\n\n\t\t\t:hover {\n\t\t    background-color: ", "15;\n\t\t  }\n\n\t\t\t:focus {\n\t\t\t\tbackground-color: none;\n\t\t\t\tbox-shadow: 0 0 0 2.5px ", "66;\n\t\t\t}\n\n\t\t\t:active {\n\t\t\t\tbackground-color: ", "33;\n\t\t\t}\n\t\t"]),
    _templateObject2 = taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\n\t\t\t:hover {\n\t\t    background-color: ", ";\n\t\t  }\n\n\t\t\t:focus {\n\t\t\t\tbackground-color: ", ";\n\t\t\t\tbox-shadow: 0 0 0 2.5px ", "66;\n\t\t\t}\n\n\t\t\t:active {\n\t\t\t\tbackground-color: ", ";\n\t\t\t}\n\t\t"], ["\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\n\t\t\t:hover {\n\t\t    background-color: ", ";\n\t\t  }\n\n\t\t\t:focus {\n\t\t\t\tbackground-color: ", ";\n\t\t\t\tbox-shadow: 0 0 0 2.5px ", "66;\n\t\t\t}\n\n\t\t\t:active {\n\t\t\t\tbackground-color: ", ";\n\t\t\t}\n\t\t"]); // This function put the right button styling


var getBtnStyle = function getBtnStyle(type, outlined, context, colors) {
  // init some variables
  var mainColor = void 0;
  var color = void 0; // Check first if there is a custom theme

  if (context) {
    // Check if the button is a primary btn
    if (type === "primary") {
      mainColor = context.primaryColor || primaryColor;
      color = context.primaryTextColor || primaryTextColor;
    } // Check if the button is a success btn
    else if (type === "success") {
        mainColor = context.successColor || successColor;
        color = context.successTextColor || successTextColor;
      } // Check if the button is a danger btn
      else if (type === "danger") {
          mainColor = context.dangerColor || dangerColor;
          color = context.dangerTextColor || dangerTextColor;
        } // otherwise it's a default button
        else {
            mainColor = context.defaultColor || defaultColor;
            color = context.defaultTextColor || defaultTextColor;
          }
  } // Default value if there is no context (no custom theming)
  else {
      if (type === "primary") {
        mainColor = primaryColor;
        color = primaryTextColor;
      } // Check if the button is a success btn
      else if (type === "success") {
          mainColor = successColor;
          color = successTextColor;
        } // Check if the button is a danger btn
        else if (type === "danger") {
            mainColor = dangerColor;
            color = dangerTextColor;
          } // otherwise it's a default button
          else {
              mainColor = defaultColor;
              color = defaultTextColor;
            }
    } // Set the default value if it's a custom colored button


  if (colors) {
    mainColor = colors.mainColor || defaultColor;
    color = colors.secondColor || defaultTextColor;
  } // init the CustomButton object


  var CustomButton = void 0; // Style the outlined buttons

  if (outlined) {
    CustomButton = styled.button(_templateObject, mainColor, mainColor, mainColor, mainColor);
  } // style the normal buttons
  else {
      CustomButton = styled.button(_templateObject2, mainColor, color, lightenDarkenColor(mainColor, 7), mainColor, mainColor, lightenDarkenColor(mainColor, -4));
    }

  return CustomButton;
};

var lightenDarkenColor = function lightenDarkenColor(col, amt) {
  // Darken or lighten color function
  // To add the darker on hover, just multiply amt by -1!!!
  var colr$$1 = new colr();
  colr$$1 = colr$$1.fromHex(col).lighten(amt).toHex();
  return colr$$1;
}; // Create the theme colors state


var ThemeContext = React.createContext();

var Button = function (_Component) {
  inherits(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.buttonClicked = function (e) {
      // Get the button onClick action done
      e.persist();
      _this.props.onClick && _this.props.onClick();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Button, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          type = _props.type,
          round = _props.round,
          outlined = _props.outlined,
          loading = _props.loading,
          colors = _props.colors; // Get the button style (rounded, outlined or loading)

      var typeStyle = "";
      var roundedClass = "";

      if (round) {
        roundedClass = styles.btnRounded;
      }

      if (outlined) {
        typeStyle = styles.btnOutlined;
      }

      var loadingBtn = "";

      if (loading) {
        loadingBtn = styles.loadingBtn;
      }

      return React.createElement(ThemeContext.Consumer, null, function (context) {
        // Get the right style for the button (Check if it's a custom theme)
        var CustomButton = getBtnStyle(type, outlined, context, colors);
        return React.createElement(CustomButton, _extends({}, _this2.props, {
          onClick: _this2.buttonClicked,
          className: styles.btn + " " + typeStyle + " " + roundedClass + " " + loadingBtn
        }), React.createElement("span", {
          style: {
            opacity: loading ? 0 : 1
          }
        }, children), loading && React.createElement("span", {
          className: styles.loadingBtnIcon
        }, React.createElement(Icon, {
          type: "loader"
        })));
      });
    }
  }]);
  return Button;
}(Component);

Button.propTypes = {
  children: PropTypes.string,
  type: PropTypes.string // round: PropTypes.boolean,

};
var css$2 = ".Card_card__1isHQ {\n\tbackground-color: #fff;\n\tborder-radius: 2px;\n\tcolor: #000000a6;\n\tline-height: 1.5;\n\tborder: 1px solid #e8e8e8;\n}\n\n.Card_cardHead__18EXw{\n\tborder-bottom: 1px solid #e8e8e8;\n\tpadding: 0 1.8rem;\n\tfont-size: 1.1rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.Card_cardHeadTitle__2hZ1z{\n\tpadding: 1.1rem 0;\n\tfont-weight: 500;\n\tmargin: 0;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n}\n\n.Card_cardBody__246oA{\n\tpadding: 1.2rem 1.8rem;\n\tborder-radius: 2px 2px 0 0;\n}\n\n.Card_noBorderCard__2Pzd-{\n\tborder: none;\n}\n\n.Card_topRightBtn__24ICZ{\n\tdisplay: flex;\n\talign-items: center;\n}\n";
var styles$2 = {
  "card": "Card_card__1isHQ",
  "cardHead": "Card_cardHead__18EXw",
  "cardHeadTitle": "Card_cardHeadTitle__2hZ1z",
  "cardBody": "Card_cardBody__246oA",
  "noBorderCard": "Card_noBorderCard__2Pzd-",
  "topRightBtn": "Card_topRightBtn__24ICZ"
};
styleInject(css$2);

var Card$7 = function (_Component) {
  inherits(Card, _Component);

  function Card() {
    classCallCheck(this, Card);
    return possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
  }

  createClass(Card, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          title = _props.title,
          children = _props.children,
          className = _props.className,
          padding = _props.padding; // Get the border style

      var borderStyle = "";

      if (border === "none") {
        borderStyle = styles$2.noBorderCard;
      } // Check if there is a title


      var cardHeader = this.props.title ? React.createElement('div', {
        className: '' + styles$2.cardHead
      }, React.createElement('div', {
        className: '' + styles$2.cardHeadTitle
      }, React.createElement('span', null, title))) : null; // Add the className if necessary

      className = className ? className : "";
      return React.createElement('div', _extends({}, this.props, {
        className: styles$2.card + ' ' + borderStyle + ' ' + className
      }), cardHeader, React.createElement('div', {
        style: padding && {
          padding: padding
        },
        className: '' + styles$2.cardBody
      }, children));
    }
  }]);
  return Card;
}(Component);

Card$7.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  border: PropTypes.string,
  className: PropTypes.string,
  padding: PropTypes.string
};
var css$3 = ".Navbar_navbar__uyJKE {\n\tbackground: #fff;\n\tbox-shadow: 0 2px 8px #f0f1f2;\n\tposition: relative;\n\tz-index: 10;\n\tmax-width: 100%;\n}\n";
var styles$3 = {
  "navbar": "Navbar_navbar__uyJKE"
};
styleInject(css$3);

var Navbar = function (_Component) {
  inherits(Navbar, _Component);

  function Navbar() {
    classCallCheck(this, Navbar);
    return possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).apply(this, arguments));
  }

  createClass(Navbar, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      return React.createElement('div', {
        className: styles$3.navbar
      }, children);
    }
  }]);
  return Navbar;
}(Component);

Navbar.propTypes = {
  children: PropTypes.node.isRequired
};
var css$4 = ".Modal_modal__9QpxU {\n  max-width: 600px;\n  margin: 1.75rem auto;\n  background: #fff;\n  z-index: 999999;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 50px;\n  border-radius: 2px;\n  transition: opacity 0.3s;\n  opacity: 1; }\n\n.Modal_modal__9QpxU.Modal_hide__NlzMG {\n  opacity: 0;\n  pointer-events: none; }\n\n.Modal_modalOverlay__31qiJ {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: #0006;\n  height: 100vh;\n  z-index: 999;\n  transition: 1s;\n  transition: opacity 0.3s;\n  opacity: 1; }\n\n.Modal_modalOverlay__31qiJ.Modal_hide__NlzMG {\n  opacity: 0;\n  pointer-events: none; }\n\n.Modal_closeModal__340nZ {\n  position: absolute;\n  top: .8rem;\n  right: .8rem;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-size: 1.3rem;\n  transition: .2s; }\n\n.Modal_closeModal__340nZ:hover {\n  opacity: .6; }\n\n.Modal_modalAnimationIn__P-pL_ {\n  animation: Modal_fadeInModal__3Ecid .2s; }\n\n@keyframes Modal_fadeInModal__3Ecid {\n  from {\n    transform: translateY(15px) scale(0.98);\n    opacity: 0; }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1; } }\n\n.Modal_modal__9QpxU { }\n\n.Modal_modalAnimationOut__ERA1i {\n  animation: Modal_fadeOutModal__3qqER .2s forwards; }\n\n@keyframes Modal_fadeOutModal__3qqER {\n  from {\n    transform: translateY(0) scale(1);\n    opacity: 1; }\n  to {\n    transform: translateY(15px) scale(0.98);\n    opacity: 0; } }\n\n.Modal_hideModal__1nQEI { }\n";
var styles$4 = {
  "modal": "Modal_modal__9QpxU Modal_modalAnimationIn__P-pL_",
  "hide": "Modal_hide__NlzMG",
  "modalOverlay": "Modal_modalOverlay__31qiJ",
  "closeModal": "Modal_closeModal__340nZ",
  "modalAnimationIn": "Modal_modalAnimationIn__P-pL_",
  "fadeInModal": "Modal_fadeInModal__3Ecid",
  "modalAnimationOut": "Modal_modalAnimationOut__ERA1i",
  "fadeOutModal": "Modal_fadeOutModal__3qqER",
  "hideModal": "Modal_hideModal__1nQEI Modal_modalAnimationOut__ERA1i"
};
styleInject(css$4);

var InnerModal = function (_Component) {
  inherits(InnerModal, _Component);

  function InnerModal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, InnerModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InnerModal.__proto__ || Object.getPrototypeOf(InnerModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isVisible: false // Make the opacity disseapear before closing the modal

    }, _this.closeModal = function () {
      // Add animation on close
      _this.setState({
        isClosing: true
      });

      setTimeout(function () {
        _this.props.toggleModal();
      }, 300);

      _this.addCloseAnimation();
    }, _this.addCloseAnimation = function () {
      document.querySelector("#modalOverlay").className = styles$4.modalOverlay + ' ' + styles$4.hide;
      document.querySelector("#modal").className = styles$4.modal + ' ' + styles$4.hideModal;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(InnerModal, [{
    key: 'componentDidMount',
    // This could be added later if fixing the problem => A bug happen when you click on close and you push on the esc button while the animation of the modal closing is finished !!!!!
    // escFunction = (e) => {
    // 	// prevent if the user is clicking and pressing on esc button
    // 	if(e.keyCode === 27){
    // 		this.closeModal();
    // 	}
    // }
    value: function componentDidMount() {
      this.props.onRef(this);
      setTimeout(function () {
        document.querySelector("#modalOverlay").className = styles$4.modalOverlay;
        document.querySelector("#modal").className = styles$4.modal;
      }, 10); // Add escape key event to close the modal
      // document.addEventListener("keydown", this.escFunction, false);

      this.setState({
        isVisible: this.props.isVisible
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Check if the modal visibility changed
      if (this.props.isVisible !== prevProps.isVisible) {
        this.setState({
          isVisible: this.props.isVisible
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // document.removeEventListener("keydown", this.escFunction, false);
      this.props.onRef(undefined);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          children = _props.children,
          isVisible = _props.isVisible;
      var _props2 = this.props,
          extra = _props2.extra,
          title = _props2.title;
      return React.createElement('div', null, React.createElement('div', {
        id: 'modalOverlay',
        onClick: this.closeModal,
        className: styles$4.modalOverlay + ' ' + styles$4.hide
      }), React.createElement('div', {
        id: 'modal',
        className: styles$4.modal
      }, React.createElement(Card$7, {
        title: title,
        border: 'shadow'
      }, React.createElement('button', {
        onClick: this.closeModal,
        className: styles$4.closeModal
      }, React.createElement(Icon, {
        type: 'close',
        size: '1.6rem',
        className: styles$4.closeIcon
      })), children)));
    }
  }]);
  return InnerModal;
}(Component);

InnerModal.propTypes = {
  title: PropTypes.string,
  isVisible: PropTypes.boolean,
  children: PropTypes.node.isRequired,
  border: PropTypes.string,
  extra: PropTypes.node
};

var ModalPortal = function (_Component) {
  inherits(ModalPortal, _Component);

  function ModalPortal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ModalPortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isVisible: false
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ModalPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        isVisible: this.props.isVisible
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this; // Check if the modal visibility changed and add animation on close


      if (this.props.isVisible !== prevProps.isVisible) {
        if (this.props.isVisible) {
          this.setState({
            isVisible: true
          });
        } else {
          this.child.addCloseAnimation();
          setTimeout(function () {
            _this2.setState({
              isVisible: false
            });
          }, 300);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.state.isVisible ? React.createElement('div', null, React.createElement(InnerModal, {
        title: this.props.title,
        onRef: function onRef(ref) {
          return _this3.child = ref;
        },
        isVisible: this.props.isVisible,
        toggleModal: this.props.toggleModal
      }, this.props.children)) : null;
    }
  }]);
  return ModalPortal;
}(Component); // Create the modal portal to hook up to the page


var Modal = function Modal(props) {
  // Check if the portal-root div exist
  var portalRoot = document.getElementById("portal-root"); // if not, add it to the body

  if (!portalRoot) {
    var _portalRoot = document.createElement("div");

    _portalRoot.id = "portal-root";
    document.body.appendChild(_portalRoot);
  } // Create a portal


  return ReactDOM.createPortal(React.createElement(ModalPortal, props), document.getElementById("portal-root"));
};

var css$5 = ".MenuItem_menuItemDiv__3zQo5 {\n  padding: 0 15px;\n  font-size: 14px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  line-height: 40px;\n  height: 40px;\n  cursor: pointer;\n  transition: .2s, border .1s;\n  color: #120000;\n  margin: 2px 1rem;\n  border-radius: 4px; }\n\n.MenuItem_menuItemDiv__3zQo5 a,\n.MenuItem_menuItemDiv__3zQo5 button {\n  text-decoration: none;\n  color: #120000;\n  transition: .2s;\n  border: none;\n  background: none;\n  font-size: 14px;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  display: flex; }\n\n.MenuItem_menuItemDiv__3zQo5:hover a,\n.MenuItem_menuItemDiv__3zQo5:hover button {\n  text-decoration: none;\n  color: #120000; }\n\n.MenuItem_menuItemWrapper__3P2sT {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: left; }\n";
var styles$5 = {
  "menuItemDiv": "MenuItem_menuItemDiv__3zQo5",
  "menuItemWrapper": "MenuItem_menuItemWrapper__3P2sT"
};
styleInject(css$5);

var MenuItem = function (_Component) {
  inherits(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isHovered: false
    }, _this.handleHoverOn = function () {
      // Handle menuItem hoover on
      _this.setState({
        isHovered: true
      });
    }, _this.handleHoverOff = function () {
      // Handle menuItem hoover off
      _this.setState({
        isHovered: false
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(MenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Add an event listener when a Link is clicked inside the MenuItem so the link work when the user click on the entire menuItem div
      var allMenuItems = document.querySelectorAll('.' + styles$5.menuItemDiv);
      allMenuItems.forEach(function (item) {
        item.addEventListener("click", function () {
          if (item.firstElementChild) {
            item.firstElementChild.click();
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isSelected = _props.isSelected,
          mainColor = _props.mainColor;
      var isSelectClass = isSelected ? styles$5.selectedMenuItem : "";
      return React.createElement(ThemeContext.Consumer, null, function (context) {
        // Get the right bg color for the menu (if custom theming)
        var mainColor = primaryColor;

        if (context) {
          mainColor = context.primaryColor;
        }

        var menuItemStyle = void 0;

        if (isSelected) {
          menuItemStyle = {
            backgroundColor: mainColor + "33",
            color: mainColor
          };
        } // Create the hover style object


        var hoverStyle = _this2.state.isHovered ? {
          backgroundColor: mainColor + "22"
        } : {}; // Change the color of the children if it's the item selected

        var childCopy = isSelected ? React.cloneElement(_this2.props.children, {
          style: {
            color: mainColor // animation: styles

          }
        }) : _this2.props.children;
        return React.createElement('div', {
          className: styles$5.menuItemDiv + ' ' + styles$5[".menuItemDiv a"] + ' ' + isSelectClass,
          style: _extends({}, menuItemStyle, hoverStyle),
          onClick: function onClick() {
            return _this2.props.changeState(_this2.props.uniqueKey);
          },
          onMouseEnter: _this2.handleHoverOn,
          onMouseLeave: _this2.handleHoverOff
        }, React.createElement('span', {
          className: styles$5.menuItemWrapper
        }, childCopy));
      });
    }
  }]);
  return MenuItem;
}(Component);

MenuItem.propTypes = {
  children: PropTypes.node.isRequired
};
var css$6 = ".Menu_menuDiv__2AdiF{\n\tborder-right: 1px solid #e8e8e8;\n\tpadding: 4px 0;\n\theight: 100%;\n\tbackground-color: #fff;\n\toverflow: scroll;\n}\n";
var styles$6 = {
  "menuDiv": "Menu_menuDiv__2AdiF"
};
styleInject(css$6);

var Menu$1 = function (_Component) {
  inherits(Menu, _Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedItem: _this.props.selectedItem
    }, _this.changeState = function (uniqueKey) {
      // Change the selectedItem in the state
      _this.setState({
        selectedItem: uniqueKey
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Menu, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Change the selected item if it have changed in the app state!
      if (this.props.selectedItem !== prevProps.selectedItem) {
        this.setState({
          selectedItem: this.props.selectedItem
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var selectedItem = this.state.selectedItem; // Pass props to children

      var childrenWithProps = React.Children.map(children, function (child) {
        // Check if its the selected menu item or not to create the component
        if (child.props.uniqueKey === selectedItem) {
          return React.cloneElement(child, {
            changeState: _this2.changeState,
            isSelected: true
          });
        }

        return React.cloneElement(child, {
          changeState: _this2.changeState,
          isSelected: false
        });
      });
      return React.createElement('div', {
        style: this.props.style,
        className: styles$6.menuDiv + ' ' + this.props.className
      }, childrenWithProps);
    }
  }]);
  return Menu;
}(Component);

Menu$1.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object
};
Menu$1.Item = MenuItem;
var css$7 = ".Messages_messageDiv__1obxZ {\n  padding: 10px 16px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.11), 0 2px 8px rgba(0, 0, 0, 0.1);\n  font-size: .9rem;\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px; }\n\n.Messages_messageWrapper__1wSO_ {\n  position: fixed;\n  top: 20px;\n  left: 0;\n  right: 0;\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column; }\n\n.Messages_msgIcon__1SUHI {\n  height: 1.4rem;\n  padding-right: 3px;\n  margin-left: -6px; }\n\n.Messages_msgAnimation__2AwAF {\n  animation: Messages_fadeInMsg__3gX3b .2s; }\n\n@keyframes Messages_fadeInMsg__3gX3b {\n  from {\n    transform: translateY(-10px);\n    opacity: 0; }\n  to {\n    transform: translateY(0);\n    opacity: 1; } }\n\n.Messages_messageDiv__1obxZ { }\n\n.Messages_msgAnimationOut__2uyOg {\n  animation: Messages_fadeOutMsg__3pmkf .2s forwards; }\n\n@keyframes Messages_fadeOutMsg__3pmkf {\n  from {\n    transform: translateY(0);\n    opacity: 1; }\n  to {\n    transform: translateY(-10px);\n    opacity: 0; } }\n\n.Messages_msgIsFadingOut__2QX3V { }\n";
var styles$7 = {
  "messageDiv": "Messages_messageDiv__1obxZ Messages_msgAnimation__2AwAF",
  "messageWrapper": "Messages_messageWrapper__1wSO_",
  "msgIcon": "Messages_msgIcon__1SUHI",
  "msgAnimation": "Messages_msgAnimation__2AwAF",
  "fadeInMsg": "Messages_fadeInMsg__3gX3b",
  "msgAnimationOut": "Messages_msgAnimationOut__2uyOg",
  "fadeOutMsg": "Messages_fadeOutMsg__3pmkf",
  "msgIsFadingOut": "Messages_msgIsFadingOut__2QX3V Messages_msgAnimationOut__2uyOg"
};
styleInject(css$7);

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M460.304 872.128L282.113 693.937c-17.183-17.183-17.183-45.043 0-62.226s45.042-17.183 62.225 0L491.416 778.79l416.486-416.486c17.183-17.183 45.043-17.183 62.226 0s17.183 45.042 0 62.225L522.529 872.128c-17.183 17.183-45.042 17.183-62.225 0z",
  fill: "#23d160",
  fillRule: "evenodd"
});

var CheckMark$1 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%221240px%22%20height%3D%221240px%22%20viewBox%3D%220%200%201240%201240%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EArtboard%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Artboard%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22_ionicons_svg_ios-checkmark%22%20transform%3D%22translate%28157.000000%2C%20-1030.000000%29%22%20fill%3D%22%2323d160%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M595.120147%2C1918.62015%20L343.120147%2C1918.62015%20C318.819618%2C1918.62015%20299.120147%2C1898.92068%20299.120147%2C1874.62015%20C299.120147%2C1850.31962%20318.819618%2C1830.62015%20343.120147%2C1830.62015%20L551.120147%2C1830.62015%20L551.120147%2C1241.62015%20C551.120147%2C1217.31962%20570.819618%2C1197.62015%20595.120147%2C1197.62015%20C619.420676%2C1197.62015%20639.120147%2C1217.31962%20639.120147%2C1241.62015%20L639.120147%2C1874.62015%20C639.120147%2C1898.92068%20619.420676%2C1918.62015%20595.120147%2C1918.62015%20Z%22%20id%3D%22Combined-Shape%22%20transform%3D%22translate%28469.120147%2C%201558.120147%29%20rotate%2845.000000%29%20translate%28-469.120147%2C%20-1558.120147%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _ref$1 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#f44",
  strokeWidth: 40
}, React.createElement("circle", {
  cx: 620,
  cy: 621,
  r: 314
}), React.createElement("path", {
  d: "M844.506 398.822L395.494 842.178"
}));

var Stop = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%221240px%22%20height%3D%221240px%22%20viewBox%3D%220%200%201240%201240%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EArtboard%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Artboard%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20stroke%3D%22%23ff4444%22%20stroke-width%3D%2240%22%20cx%3D%22620%22%20cy%3D%22621%22%20r%3D%22314%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M622%2C305%20L618%2C936%22%20id%3D%22Path-7%22%20stroke%3D%22%23ff4444%22%20stroke-width%3D%2240%22%20transform%3D%22translate%28620.000000%2C%20620.500000%29%20rotate%2845.000000%29%20translate%28-620.000000%2C%20-620.500000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _ref$2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M620 220c220.962 0 400 179.038 400 400s-179.038 400-400 400-400-179.038-400-400 179.038-400 400-400zm-24.298 471.347h48.539l10.086-214.957 2.521-71.863h-73.123l1.891 71.863 10.086 214.957zm24.585 143.094c13.448 0 24.584-4.622 33.41-13.868 8.825-9.245 13.237-21.012 13.237-35.3 0-14.29-4.412-26.056-13.238-35.302-8.825-9.245-19.961-13.868-33.41-13.868-13.447 0-24.689 4.623-33.724 13.868-9.036 9.246-13.553 21.013-13.553 35.301 0 14.289 4.517 26.056 13.553 35.301 9.035 9.246 20.277 13.868 33.725 13.868z",
  fill: "#006eff",
  fillRule: "evenodd"
});

var Exclamation = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%221240px%22%20height%3D%221240px%22%20viewBox%3D%220%200%201240%201240%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EArtboard%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Artboard%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M620%2C220%20C840.961538%2C220%201020%2C399.038462%201020%2C620%20C1020%2C840.961538%20840.961538%2C1020%20620%2C1020%20C399.038462%2C1020%20220%2C840.961538%20220%2C620%20C220%2C399.038462%20399.038462%2C220%20620%2C220%20Z%20M595.702006%2C691.346705%20L644.240688%2C691.346705%20L654.326648%2C476.389685%20L656.848138%2C404.527221%20L583.724928%2C404.527221%20L585.616046%2C476.389685%20L595.702006%2C691.346705%20Z%20M620.286533%2C834.441261%20C633.734547%2C834.441261%20644.871016%2C829.818575%20653.696275%2C820.573066%20C662.521534%2C811.327556%20666.934097%2C799.560721%20666.934097%2C785.272206%20C666.934097%2C770.983692%20662.521534%2C759.216856%20653.696275%2C749.971347%20C644.871016%2C740.725837%20633.734547%2C736.103152%20620.286533%2C736.103152%20C606.838519%2C736.103152%20595.596989%2C740.725837%20586.561605%2C749.971347%20C577.52622%2C759.216856%20573.008596%2C770.983692%20573.008596%2C785.272206%20C573.008596%2C799.560721%20577.52622%2C811.327556%20586.561605%2C820.573066%20C595.596989%2C829.818575%20606.838519%2C834.441261%20620.286533%2C834.441261%20Z%22%20id%3D%22Combined-Shape%22%20fill%3D%22%23006eff%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _ref$3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M620 220c220.962 0 400 179.038 400 400s-179.038 400-400 400-400-179.038-400-400 179.038-400 400-400zm-39.713 475.473h63.667c-1.68-13.448-.525-25.635 3.467-36.562a142.71 142.71 0 0 1 15.76-30.888c6.513-9.666 13.868-18.911 22.063-27.736a322.053 322.053 0 0 0 23.008-27.737c7.144-9.666 13.133-19.857 17.966-30.573 4.833-10.716 7.249-22.798 7.249-36.246 0-17.23-2.837-32.36-8.51-45.387-5.673-13.028-13.448-23.954-23.324-32.78-9.876-8.825-21.748-15.444-35.616-19.856-13.868-4.413-28.997-6.62-45.387-6.62-23.954 0-45.491 5.149-64.613 15.445-19.121 10.296-35.616 23.429-49.484 39.398l40.344 37.192c9.245-10.086 19.121-18.07 29.627-23.954 10.507-5.883 22.273-8.825 35.301-8.825 15.97 0 28.472 4.623 37.507 13.868 9.036 9.246 13.553 21.433 13.553 36.562 0 9.665-2.311 18.7-6.934 27.106-4.623 8.405-10.4 16.915-17.335 25.53a1050.836 1050.836 0 0 1-22.063 26.475c-7.775 9.036-14.709 18.806-20.802 29.313-6.094 10.506-10.717 22.063-13.869 34.67-3.151 12.608-3.677 26.476-1.575 41.605zm32.149 143.094c13.448 0 24.69-4.622 33.724-13.868 9.036-9.245 13.553-21.012 13.553-35.3 0-14.29-4.517-26.056-13.553-35.302-9.035-9.245-20.276-13.868-33.724-13.868-13.448 0-24.585 4.623-33.41 13.868-8.825 9.246-13.238 21.013-13.238 35.301 0 14.289 4.413 26.056 13.238 35.301 8.825 9.246 19.962 13.868 33.41 13.868z",
  fill: "#5f636866",
  fillRule: "evenodd"
});

var Question = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%221240px%22%20height%3D%221240px%22%20viewBox%3D%220%200%201240%201240%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EArtboard%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Artboard%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M620%2C220%20C840.961538%2C220%201020%2C399.038462%201020%2C620%20C1020%2C840.961538%20840.961538%2C1020%20620%2C1020%20C399.038462%2C1020%20220%2C840.961538%20220%2C620%20C220%2C399.038462%20399.038462%2C220%20620%2C220%20Z%20M580.286533%2C695.472779%20L643.954155%2C695.472779%20C642.273153%2C682.024766%20643.428824%2C669.837686%20647.421203%2C658.911175%20C651.413583%2C647.984664%20656.666634%2C637.688683%20663.180516%2C628.022923%20C669.694397%2C618.357163%20677.04867%2C609.111792%20685.243553%2C600.286533%20C693.438436%2C591.461274%20701.107892%2C582.215903%20708.252149%2C572.550143%20C715.396406%2C562.884383%20721.384885%2C552.693463%20726.217765%2C541.977077%20C731.050645%2C531.260691%20733.467049%2C519.178673%20733.467049%2C505.730659%20C733.467049%2C488.500391%20730.630401%2C473.371603%20724.95702%2C460.34384%20C719.283639%2C447.316076%20711.509123%2C436.389729%20701.633238%2C427.56447%20C691.757353%2C418.739211%20679.885456%2C412.120366%20666.017192%2C407.707736%20C652.148928%2C403.295107%20637.020139%2C401.088825%20620.630372%2C401.088825%20C596.676098%2C401.088825%20575.138587%2C406.236816%20556.017192%2C416.532951%20C536.895797%2C426.829087%20520.401215%2C439.961716%20506.532951%2C455.931232%20L546.876791%2C493.123209%20C556.1223%2C483.037199%20565.998037%2C475.05256%20576.504298%2C469.169054%20C587.010559%2C463.285548%20598.777394%2C460.34384%20611.805158%2C460.34384%20C627.774674%2C460.34384%20640.276937%2C464.966525%20649.312321%2C474.212034%20C658.347705%2C483.457544%20662.86533%2C495.644623%20662.86533%2C510.773639%20C662.86533%2C520.439399%20660.553987%2C529.474648%20655.931232%2C537.879656%20C651.308477%2C546.284665%20645.530121%2C554.794608%20638.595989%2C563.409742%20C631.661856%2C572.024876%20624.307584%2C580.850003%20616.532951%2C589.885387%20C608.758318%2C598.920771%20601.82429%2C608.691447%20595.730659%2C619.197708%20C589.637028%2C629.703968%20585.014342%2C641.260682%20581.862464%2C653.868195%20C578.710586%2C666.475708%20578.185281%2C680.343764%20580.286533%2C695.472779%20Z%20M612.43553%2C838.567335%20C625.883544%2C838.567335%20637.125074%2C833.94465%20646.160458%2C824.69914%20C655.195843%2C815.453631%20659.713467%2C803.686795%20659.713467%2C789.398281%20C659.713467%2C775.109766%20655.195843%2C763.342931%20646.160458%2C754.097421%20C637.125074%2C744.851912%20625.883544%2C740.229226%20612.43553%2C740.229226%20C598.987516%2C740.229226%20587.851047%2C744.851912%20579.025788%2C754.097421%20C570.200529%2C763.342931%20565.787966%2C775.109766%20565.787966%2C789.398281%20C565.787966%2C803.686795%20570.200529%2C815.453631%20579.025788%2C824.69914%20C587.851047%2C833.94465%20598.987516%2C838.567335%20612.43553%2C838.567335%20Z%22%20id%3D%22Combined-Shape%22%20fill%3D%22%235f636866%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var message = function message(text, type) {
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2.5; // This could be modified using React Portal!!!!
  // Transfert the time in milliseconds

  time = time * 1000; // Add an animation delay of 0.2s

  var animationDelay = 200; // Remove the message from the dom if still there

  var elem = document.querySelectorAll('.' + styles$7.messageWrapper);

  if (elem[0]) {
    // Put the display to none if there is already some messages
    elem.forEach(function (item) {
      item.style.display = "none";
    });
  } // Create the outer div of the message (used to center the message)


  var outerNode = document.createElement("div");
  outerNode.className = styles$7.messageWrapper; // Create the div of the message

  var node = document.createElement("div");
  node.className = styles$7.messageDiv; // Check the message type to show the right icon

  if (type !== "noIcon") {
    var domImg = document.createElement("img");

    if (type === "success") {
      domImg.src = CheckMark$1;
    } else if (type === "error") {
      domImg.src = Stop;
    } else if (type === "question") {
      domImg.src = Question;
    } else {
      domImg.src = Exclamation;
    }

    domImg.className = styles$7.msgIcon;
    node.appendChild(domImg);
  } // Add the text to the message


  var textnode = document.createTextNode(text);
  node.appendChild(textnode);
  outerNode.appendChild(node);
  document.body.appendChild(outerNode); // Set a timeout to remove the message

  var removeMess = setTimeout(function () {
    var elem = document.querySelector('.' + styles$7.messageWrapper);

    if (elem) {
      elem.parentNode.removeChild(elem);
    }
  }, time); // Set a timeout to add the fadeOut animation

  var endAnim = setTimeout(function () {
    var msgDiv = document.querySelector('.' + styles$7.messageWrapper);

    if (msgDiv) {
      msgDiv.className = styles$7.messageWrapper + ' ' + styles$7.msgIsFadingOut;
    }
  }, time - animationDelay);
};

var css$8 = ".Input_inputWrapper__3vuaX {\n  position: relative; }\n\n.Input_inputIcon__hNBbw {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 4px;\n  opacity: .3;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: calc(0px + 1px);\n  line-height: 0;\n  height: 100%; }\n\n.Input_inputWrapper__3vuaX > input {\n  outline: none;\n  font-size: 1rem;\n  padding: .3rem .6rem;\n  border-radius: 4px;\n  border: 1px solid #d4d6d8;\n  transition: all .2s, padding 0s;\n  width: 100%; }\n  .Input_inputWrapper__3vuaX > input:hover {\n    border-color: #92969b; }\n  .Input_inputWrapper__3vuaX > input:active {\n    border-color: #006eff; }\n  .Input_inputWrapper__3vuaX > input::placeholder {\n    color: #acb0b4; }\n\n.Input_inputWrapper__3vuaX > textArea {\n  outline: none;\n  font-size: 1rem;\n  padding: .3rem .6rem;\n  border-radius: 4px;\n  border: 1px solid #d4d6d8;\n  transition: all .2s, padding 0s;\n  width: 100%; }\n  .Input_inputWrapper__3vuaX > textArea:hover {\n    border-color: #92969b; }\n  .Input_inputWrapper__3vuaX > textArea:active {\n    border-color: #006eff; }\n  .Input_inputWrapper__3vuaX > textArea::placeholder {\n    color: #acb0b4; }\n";
var styles$8 = {
  "inputWrapper": "Input_inputWrapper__3vuaX",
  "inputIcon": "Input_inputIcon__hNBbw"
};
styleInject(css$8);

var _templateObject$1 = taggedTemplateLiteral(['\n\t\t\t\t\t\t:focus {\n\t\t\t\t\t\t\tborder-color: ', 'bb !important;\n\t\t\t\t\t\t\tbox-shadow: 0 0 0 3px ', '40  !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t:active\xA0{\n\t\t\t\t\t\t\tborder-color: ', ' !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t'], ['\n\t\t\t\t\t\t:focus {\n\t\t\t\t\t\t\tborder-color: ', 'bb !important;\n\t\t\t\t\t\t\tbox-shadow: 0 0 0 3px ', '40  !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t:active\xA0{\n\t\t\t\t\t\t\tborder-color: ', ' !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t']);

var Input = function (_Component) {
  inherits(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputId: "input_" + uid_1(10),
      fontSize: null,
      iconIsReady: false
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Get the necessary padding if the input have an icon
      if (this.props.icon) {
        var element = document.getElementById(this.state.inputId);
        var elementStyle = getComputedStyle(element); // Get the font size if there is no size specified

        var fontSize = elementStyle["font-size"];
        this.setState({
          fontSize: fontSize,
          iconIsReady: true
        });
      } else {
        this.setState({
          iconIsReady: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          type = _props.type,
          className = _props.className,
          icon = _props.icon;
      var _state = this.state,
          fontSize = _state.fontSize,
          iconIsReady = _state.iconIsReady; // Add the classNAme to the icon

      className = className ? className : ""; // Check if it's an input with icon and add style if its the case

      var inputWithIcon = icon ? styles$8.inputWithIcon : ""; // // Check if there is a specified font size (to have the right icon size)

      var specifiedFontSize = null;

      if (icon) {
        if (this.props.style) {
          specifiedFontSize = this.props.style.fontSize;
        }
      }

      return React.createElement(ThemeContext.Consumer, null, function (context) {
        // Get the right style for the input
        var mainColor = primaryColor; // Check if there is an existing custom theming in the context

        if (context) {
          mainColor = context.primaryColor;
        } // Get the right style for the button


        var CustomInput = styled.input(_templateObject$1, mainColor, mainColor, mainColor);
        return React.createElement('span', {
          style: {
            fontSize: specifiedFontSize // opacity: iconIsReady ? 1 : 0,

          },
          className: styles$8.inputWrapper
        }, React.createElement(CustomInput, _extends({}, _this2.props, {
          id: _this2.state.inputId,
          className: className + ' ' + inputWithIcon + ' ' + styles$8.input,
          style: _extends({}, _this2.props.style, {
            paddingLeft: '' + ('calc(' + fontSize + ' * 1.5)')
          })
        })), icon && React.createElement('span', {
          style: {
            paddingTop: '' + ('calc(' + fontSize + ' * 0)'),
            fontSize: fontSize
          },
          className: styles$8.inputIcon
        }, React.createElement(Icon, {
          type: icon
        })));
      });
    }
  }]);
  return Input;
}(Component);

Input.propTypes = {
  children: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string
};

var _templateObject$2 = taggedTemplateLiteral(['\n\t\t\t\t\t\t:focus {\n\t\t\t\t\t\t\tborder-color: ', 'bb !important;\n\t\t\t\t\t\t\tbox-shadow: 0 0 0 3px ', '40  !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t:active\xA0{\n\t\t\t\t\t\t\tborder-color: ', ' !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t'], ['\n\t\t\t\t\t\t:focus {\n\t\t\t\t\t\t\tborder-color: ', 'bb !important;\n\t\t\t\t\t\t\tbox-shadow: 0 0 0 3px ', '40  !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t:active\xA0{\n\t\t\t\t\t\t\tborder-color: ', ' !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t']);

var TextArea = function (_Component) {
  inherits(TextArea, _Component);

  function TextArea() {
    classCallCheck(this, TextArea);
    return possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));
  }

  createClass(TextArea, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          type = _props.type;
      var className = "";
      return React.createElement(ThemeContext.Consumer, null, function (context) {
        // Get the right style for the textarea
        var mainColor = primaryColor; // Check if there is an existing context (custom theming)

        if (context) {
          mainColor = context.primaryColor;
        }

        var CustomTextArea = styled.textarea(_templateObject$2, mainColor, mainColor, mainColor);
        return React.createElement('span', {
          className: styles$8.inputWrapper
        }, React.createElement(CustomTextArea, _extends({}, _this2.props, {
          className: styles$8.textInput + ' ' + className
        })));
      });
    }
  }]);
  return TextArea;
}(Component);

TextArea.propTypes = {
  children: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string
};
var css$9 = ".Table_tableScroll__zRwCt {\n  overflow: scroll; }\n\n.Table_tableWrapper__1fXsJ {\n  border-radius: 4px;\n  border: 1px solid #e8e8e8; }\n\n.Table_tableWrapper__1fXsJ .Table_table__1DoSj th,\n.Table_tableWrapper__1fXsJ .Table_table__1DoSj td {\n  border-bottom: 1px solid #e8e8e8;\n  border-right: 1px solid #e8e8e8; }\n\n.Table_tableWrapper__1fXsJ .Table_table__1DoSj td:last-child,\n.Table_tableWrapper__1fXsJ .Table_table__1DoSj th:last-child {\n  border-right: none; }\n\n.Table_table__1DoSj {\n  width: 100%;\n  text-align: left;\n  border-collapse: collapse; }\n\n.Table_table__1DoSj th,\n.Table_table__1DoSj td {\n  padding: .8rem 1rem; }\n\n.Table_table__1DoSj th {\n  background-color: #00000006;\n  font-weight: normal;\n  color: #000a; }\n\n.Table_table__1DoSj th {\n  border-bottom: 1px solid #e8e8e8; }\n\n.Table_table__1DoSj td {\n  border-bottom: 1px solid #e8e8e8; }\n\n.Table_table__1DoSj tr:last-child td {\n  border-bottom: none; }\n\n.Table_table__1DoSj tbody tr {\n  transition: .1s; }\n";
var styles$9 = {
  "tableScroll": "Table_tableScroll__zRwCt",
  "tableWrapper": "Table_tableWrapper__1fXsJ",
  "table": "Table_table__1DoSj"
};
styleInject(css$9);

var _templateObject$3 = taggedTemplateLiteral(['\n\t\t\t\t\t\t:hover {\n\t\t\t\t\t\t\tbackground-color: ', '0c;\n\t\t\t\t\t\t}\n\t\t\t\t\t'], ['\n\t\t\t\t\t\t:hover {\n\t\t\t\t\t\t\tbackground-color: ', '0c;\n\t\t\t\t\t\t}\n\t\t\t\t\t']);

var Table = function (_Component) {
  inherits(Table, _Component);

  function Table() {
    classCallCheck(this, Table);
    return possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  createClass(Table, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(ThemeContext.Consumer, null, function (context) {
        // Get the right style for the button
        var hoverColor = primaryColor; // Check if there is an existing context (custom theming)

        if (context) {
          hoverColor = context.primaryColor;
        }

        var CustomTR = styled.tr(_templateObject$3, hoverColor);
        return React.createElement('div', {
          style: _this2.props.style,
          className: (_this2.props.bordered && styles$9.tableWrapper) + ' ' + styles$9.tableScroll + ' ' + _this2.props.className
        }, React.createElement('table', {
          className: styles$9.table
        }, React.createElement('thead', null, React.createElement('tr', null, _this2.props.columns.map(function (column, i) {
          return React.createElement('th', {
            key: i
          }, column);
        }))), React.createElement('tbody', null, _this2.props.rows.map(function (row, i) {
          return React.createElement(CustomTR, {
            key: i
          }, _this2.props.columns.map(function (column, j) {
            return React.createElement('td', {
              key: j
            }, row[column]);
          }));
        }))));
      });
    }
  }]);
  return Table;
}(Component);

Table.propTypes = {
  columns: PropTypes.array,
  rows: PropTypes.array
};
var css$a = ".Drawer_drawer__38XLS {\n  position: relative;\n  height: 100%;\n  width: 300px;\n  background-color: #fff;\n  z-index: 999999;\n  padding: 1rem;\n  box-shadow: 0 0 10px 10px #0001;\n  padding-top: 2.6rem; }\n\n.Drawer_drawerWrapper__BbY2X {\n  z-index: 999;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0; }\n\n.Drawer_drawerWrapperRight__3dijJ {\n  z-index: 999;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0; }\n\n.Drawer_drawerOverlay__3fWjr {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  background-color: #0003;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: -1;\n  cursor: pointer; }\n\n.Drawer_closeDrawer__2Wskf {\n  background: none;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  outline: none;\n  transition: .2s; }\n\n.Drawer_closeDrawer__2Wskf:hover {\n  opacity: .6; }\n\n@keyframes Drawer_slideIn__2TBV8 {\n  0% {\n    transform: translateX(-100%); }\n  100% {\n    transform: translateX(0); } }\n\n.Drawer_drawerAnimationIn__iGdLZ {\n  animation: Drawer_slideIn__2TBV8 .3s forwards; }\n\n.Drawer_drawer__38XLS { }\n\n@keyframes Drawer_slideOut__2w2uq {\n  0% {\n    transform: translateX(0); }\n  100% {\n    transform: translateX(-100%); } }\n\n.Drawer_drawerAnimationOut__-c0Xs {\n  animation: Drawer_slideOut__2w2uq .3s forwards; }\n\n.Drawer_drawerOut__25iDr { }\n\n@keyframes Drawer_slideInRight__3V-kl {\n  0% {\n    transform: translateX(100%); }\n  100% {\n    transform: translateX(0); } }\n\n.Drawer_drawerAnimationRightIn__2yrrE {\n  animation: Drawer_slideInRight__3V-kl .3s forwards; }\n\n.Drawer_drawerRight__2nMSG { }\n\n@keyframes Drawer_slideOutRight__1BiGj {\n  0% {\n    transform: translateX(0); }\n  100% {\n    transform: translateX(100%); } }\n\n.Drawer_drawerAnimationOutRight__242rW {\n  animation: Drawer_slideOutRight__1BiGj .3s forwards; }\n\n.Drawer_drawerOutRight__2ZEFc { }\n\n@keyframes Drawer_fadeIn__1fWxJ {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n.Drawer_drawerOverlayAnimIn__3GdwG {\n  animation: Drawer_fadeIn__1fWxJ .3s forwards; }\n\n.Drawer_drawerOverlay__3fWjr { }\n\n@keyframes Drawer_fadeOut__28p9D {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.Drawer_drawerOverlayAnimOut__ayQQB {\n  animation: Drawer_fadeOut__28p9D .3s forwards; }\n\n.Drawer_drawerOverlayOut__3a-VD { }\n";
var styles$a = {
  "drawer": "Drawer_drawer__38XLS Drawer_drawerAnimationIn__iGdLZ",
  "drawerWrapper": "Drawer_drawerWrapper__BbY2X",
  "drawerWrapperRight": "Drawer_drawerWrapperRight__3dijJ",
  "drawerOverlay": "Drawer_drawerOverlay__3fWjr Drawer_drawerOverlayAnimIn__3GdwG",
  "closeDrawer": "Drawer_closeDrawer__2Wskf",
  "drawerAnimationIn": "Drawer_drawerAnimationIn__iGdLZ",
  "slideIn": "Drawer_slideIn__2TBV8",
  "drawerAnimationOut": "Drawer_drawerAnimationOut__-c0Xs",
  "slideOut": "Drawer_slideOut__2w2uq",
  "drawerOut": "Drawer_drawerOut__25iDr Drawer_drawerAnimationOut__-c0Xs",
  "drawerAnimationRightIn": "Drawer_drawerAnimationRightIn__2yrrE",
  "slideInRight": "Drawer_slideInRight__3V-kl",
  "drawerRight": "Drawer_drawerRight__2nMSG Drawer_drawerAnimationRightIn__2yrrE",
  "drawerAnimationOutRight": "Drawer_drawerAnimationOutRight__242rW",
  "slideOutRight": "Drawer_slideOutRight__1BiGj",
  "drawerOutRight": "Drawer_drawerOutRight__2ZEFc Drawer_drawerAnimationOutRight__242rW",
  "drawerOverlayAnimIn": "Drawer_drawerOverlayAnimIn__3GdwG",
  "fadeIn": "Drawer_fadeIn__1fWxJ",
  "drawerOverlayAnimOut": "Drawer_drawerOverlayAnimOut__ayQQB",
  "fadeOut": "Drawer_fadeOut__28p9D",
  "drawerOverlayOut": "Drawer_drawerOverlayOut__3a-VD Drawer_drawerOverlayAnimOut__ayQQB"
};
styleInject(css$a);

var DrawerPortal = function (_Component) {
  inherits(DrawerPortal, _Component);

  function DrawerPortal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, DrawerPortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DrawerPortal.__proto__ || Object.getPrototypeOf(DrawerPortal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showDrawer: false,
      drawerId: "drawer_" + uid_1(10),
      drawerOverlayId: "drawerOverlay_" + uid_1(10)
    }, _this.closeDrawer = function () {
      var showDrawer = _this.props.showDrawer; // add animation depending if it's a right or left drawer

      setTimeout(function () {
        _this.setState({
          showDrawer: showDrawer
        });
      }, 300);

      if (_this.props.position === "right") {
        document.querySelector('#' + _this.state.drawerId).className = styles$a.drawer + ' ' + styles$a.drawerOutRight;
      } else {
        document.querySelector('#' + _this.state.drawerId).className = styles$a.drawer + ' ' + styles$a.drawerOut;
      }

      document.querySelector('#' + _this.state.drawerOverlayId).className = styles$a.drawerOverlay + ' ' + styles$a.drawerOverlayOut;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(DrawerPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var showDrawer = this.props.showDrawer;
      this.setState({
        showDrawer: showDrawer
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var showDrawer = this.props.showDrawer; // Add an animation to the drawer on close

      if (showDrawer !== prevProps.showDrawer) {
        if (!showDrawer) {
          this.closeDrawer();
        } else {
          this.setState({
            showDrawer: showDrawer
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // Check whether if the drawer is at left (default) or at right
      var drawerPositionClass = this.props.position === "right" ? styles$a.drawerWrapperRight : styles$a.drawerWrapper;
      var drawerClass = this.props.position === "right" ? styles$a.drawer + ' ' + styles$a.drawerRight : styles$a.drawer;
      return this.state.showDrawer && React.createElement('div', {
        className: drawerPositionClass
      }, React.createElement('div', {
        id: this.state.drawerId,
        style: this.props.style,
        className: drawerClass
      }, this.props.isClosable && React.createElement('button', {
        className: styles$a.closeDrawer,
        onClick: this.props.toggleDrawer
      }, React.createElement(Icon, {
        type: 'close',
        size: '1.6rem',
        className: styles$a.closeDrawerIcon
      })), this.props.children), React.createElement('div', {
        id: this.state.drawerOverlayId,
        onClick: this.props.toggleDrawer,
        className: styles$a.drawerOverlay
      }));
    }
  }]);
  return DrawerPortal;
}(Component);

DrawerPortal.propTypes = {
  columns: PropTypes.array,
  rows: PropTypes.array
};
DrawerPortal.defaultProps = {
  isClosable: true // Create a portal to hook the Drawer into

};

var Drawer = function Drawer(props) {
  // Check if the portal-root div exist
  var portalRoot = document.getElementById("portal-root"); // if not, add it to the body

  if (!portalRoot) {
    var _portalRoot = document.createElement("div");

    _portalRoot.id = "portal-root";
    document.body.appendChild(_portalRoot);
  } // Create a portal to attach the drawer


  return ReactDOM.createPortal(React.createElement(DrawerPortal, props), document.getElementById("portal-root"));
};

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ThemeProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      defaultColor: _this.props.theme.defaultColor || defaultColor,
      defaultTextColor: _this.props.theme.defaultTextColor || defaultTextColor,
      primaryColor: _this.props.theme.primaryColor || primaryColor,
      primaryTextColor: _this.props.theme.primaryTextColor || primaryTextColor,
      successColor: _this.props.theme.successColor || successColor,
      successTextColor: _this.props.theme.successTextColor || successTextColor,
      dangerColor: _this.props.theme.dangerColor || dangerColor,
      dangerTextColor: _this.props.theme.dangerTextColor || dangerTextColor
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ThemeProvider, [{
    key: "render",
    value: function render() {
      var _state = this.state,
          defaultColor$$1 = _state.defaultColor,
          defaultTextColor$$1 = _state.defaultTextColor,
          primaryColor$$1 = _state.primaryColor,
          primaryTextColor$$1 = _state.primaryTextColor,
          successColor$$1 = _state.successColor,
          successTextColor$$1 = _state.successTextColor,
          dangerColor$$1 = _state.dangerColor,
          dangerTextColor$$1 = _state.dangerTextColor;
      return React.createElement(ThemeContext.Provider, {
        value: {
          defaultColor: defaultColor$$1,
          defaultTextColor: defaultTextColor$$1,
          primaryColor: primaryColor$$1,
          primaryTextColor: primaryTextColor$$1,
          successColor: successColor$$1,
          successTextColor: successTextColor$$1,
          dangerColor: dangerColor$$1,
          dangerTextColor: dangerTextColor$$1
        }
      }, this.props.children);
    }
  }]);
  return ThemeProvider;
}(Component);

ThemeProvider.contextType = ThemeContext;
var gutterSize = "12px";

var _templateObject$4 = taggedTemplateLiteral(["\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin-right: -", ";\n\t\tmargin-left: -", ";\n\t"], ["\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin-right: -", ";\n\t\tmargin-left: -", ";\n\t"]);

var Row = function Row(props) {
  var CustomRow = styled.div(_templateObject$4, gutterSize, gutterSize);
  return React.createElement(CustomRow, props, props.children);
};

var css$b = ".Container_flwww-container-full__kM5SY {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto; }\n\n.Container_flwww-container__3H2Ye {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto; }\n  @media (min-width: 576px) {\n    .Container_flwww-container__3H2Ye {\n      max-width: 540px; } }\n  @media (min-width: 768px) {\n    .Container_flwww-container__3H2Ye {\n      max-width: 720px; } }\n  @media (min-width: 992px) {\n    .Container_flwww-container__3H2Ye {\n      max-width: 960px; } }\n  @media (min-width: 1200px) {\n    .Container_flwww-container__3H2Ye {\n      max-width: 1140px; } }\n";
var styles$b = {
  "flwww-container-full": "Container_flwww-container-full__kM5SY",
  "flwww-container": "Container_flwww-container__3H2Ye"
};
styleInject(css$b);

var Container = function Container(props) {
  // Add class to the container
  var containerClass = void 0;

  if (props.full) {
    containerClass = styles$b["flwww-container-full"];
  } else {
    containerClass = styles$b["flwww-container"];
  }

  return React.createElement("div", _extends({
    className: containerClass
  }, props, {
    style: {
      paddingRight: gutterSize,
      paddingLeft: gutterSize
    }
  }), props.children);
};

var formatColStyle = function formatColStyle(gridName, deviceSize, colWidth) {
  // A simple function to format the col styling
  var style = ""; // Check if it's an offset class

  if (gridName.split("-").includes("offset")) {
    style += "\n\t\t\t@media (min-width: " + deviceSize + "){\n\t\t\t\tmargin-left: " + colWidth + "%;\n\t\t\t}\n\t\t";
  } else {
    style += "\n\t\t\t@media (min-width: " + deviceSize + "){\n\t\t\t\tmax-width: " + colWidth + "%;\n\t\t\t\tflex: 0 0 " + colWidth + "%;\n\t\t\t}\n\t\t";
  }

  return style;
};

var _templateObject$5 = taggedTemplateLiteral(["\n\t\t", "\n\t\t", "\n\t"], ["\n\t\t", "\n\t\t", "\n\t"]);

var Col = function Col(props) {
  // Default styling for any col
  var colStyle = "\n\t\tposition: relative;\n\t  width: 100%;\n\t  padding-right: " + gutterSize + ";\n\t  padding-left: " + gutterSize + ";\n\t"; // Format the right width for the cols

  var colClass = void 0;

  if (props.grid) {
    colClass = props.grid.split(" ");
  } // Setup some variables for media queries


  var smallDevice = "576px";
  var mediumDevice = "768px";
  var largeDevice = "992px";
  var xlDevice = "1200px"; // add the grid style to the div

  var gridStyle = "";
  colClass.forEach(function (cls) {
    // get the percent or the width
    var classArray = cls.split("-");
    var prcntWidth = 100 / 12 * classArray[classArray.length - 1]; // Check if it contain media queries grid
    // SMALL DEVICES

    if (cls.split("-").includes("sm")) {
      gridStyle += formatColStyle(cls, smallDevice, prcntWidth);
    } // MEDIUM DEVICE
    else if (cls.split("-").includes("md")) {
        gridStyle += formatColStyle(cls, mediumDevice, prcntWidth);
      } // LARGE DEVICE
      else if (cls.split("-").includes("lg")) {
          gridStyle += formatColStyle(cls, largeDevice, prcntWidth);
        } // XL DEVICE
        else if (cls.split("-").includes("xl")) {
            gridStyle += formatColStyle(cls, xlDevice, prcntWidth);
          } else {
            if (cls.split("-").includes("offset")) {
              gridStyle += "\n\t\t\t\t  margin-left: " + prcntWidth + "%;\n\t\t\t\t";
            } else {
              gridStyle += "\n\t\t\t\t\tmax-width: " + prcntWidth + "%;\n\t\t\t\t\tflex: 0 0 " + prcntWidth + "%;\n\t\t\t\t";
            }
          }
  });
  var CustomCol = styled.div(_templateObject$5, colStyle, gridStyle);
  return React.createElement(CustomCol, props, props.children);
};

var css$c = "html {\n  box-sizing: border-box !important;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit !important;\n}\n";
styleInject(css$c);
var css$d = "";
styleInject(css$d);

var ExampleComponent = function (_Component) {
  inherits(ExampleComponent, _Component);

  function ExampleComponent() {
    classCallCheck(this, ExampleComponent);
    return possibleConstructorReturn(this, (ExampleComponent.__proto__ || Object.getPrototypeOf(ExampleComponent)).apply(this, arguments));
  }

  createClass(ExampleComponent, [{
    key: 'render',
    value: function render() {
      var text = this.props.text;
      return React.createElement('div', null, 'Hello World!');
    }
  }]);
  return ExampleComponent;
}(Component);

ExampleComponent.propTypes = {
  text: PropTypes.string
};
export default ExampleComponent;
export { Button, Card$7 as Card, Navbar, Modal, Menu$1 as Menu, Icon, message, Input, TextArea, Table, Drawer, ThemeProvider, Container, Row, Col };